import * as i0 from '@angular/core';
import { EventEmitter, Component, ViewEncapsulation, ChangeDetectionStrategy, Input, Output, HostBinding, HostListener, Injectable, InjectionToken, Inject, NgModule } from '@angular/core';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i3 from '@play/translate';
import { TranslationModule } from '@play/translate';
import * as i1 from '@play/common';
import { InheritClassComponent, CommonsComponentModule, CommonsLocationModule, CommonsLoadingModule, CommonsErrorModule } from '@play/common';
import { type, queueReducers, LoadTeamsOnceAction, getTeams, LoadPlayersOnceAction, getPlayers, LoadLeagueOnceAction, getLeague, LoadParticipantsOnceAction, getLeagueParticipants, exists, getUser, entryAvailable, LoadContestantsOnceAction, getContestants, LoadLeagueResultsOnceAction, getLeagueResults, distinct } from '@play/state';
import { reduce, findIndex, range, last, sample, slice, first, chunk, isUndefined, assign, debounce, throttle, orderBy, groupBy, map as map$1, find, findLast, sortBy, findLastIndex, maxBy, minBy, keyBy } from 'lodash';
import * as i1$1 from '@ngrx/store';
import { StoreModule } from '@ngrx/store';
import { of, combineLatest, BehaviorSubject } from 'rxjs';
import { playersToDictionary } from '@play/utility/player';
import { teamsToDictionary } from '@play/utility/team';
import * as i4 from '@play/premium';
import { PremiumModule } from '@play/premium';
import { isTeam, isRosterEnabled } from '@play/utility/league';
import { map, filter, switchMap } from 'rxjs/operators';
import * as i9 from '@play/cup-page';
import { SelectParticipantAction, isCheckedIn, InitSelectedParticipantAction, getSelectedParticipant, CupPageModule } from '@play/cup-page';
import * as i2$1 from '@play/path-view';
import { PathViewStatsBoxModule, PathViewModule } from '@play/path-view';

const _c0$6 = function (a0, a1, a2) { return { "cup-bracket-selector__button--active": a0, "cup-bracket-selector__button--left": a1, "cup-bracket-selector__button--right": a2 }; };
const _c1$1 = ["*"];
class CupBracketSelectorButtonComponent {
    constructor() {
        this.clicked = new EventEmitter();
    }
}
CupBracketSelectorButtonComponent.ɵfac = function CupBracketSelectorButtonComponent_Factory(t) { return new (t || CupBracketSelectorButtonComponent)(); };
CupBracketSelectorButtonComponent.ɵcmp = i0.ɵɵdefineComponent({ type: CupBracketSelectorButtonComponent, selectors: [["cup-bracket-selector-button"]], inputs: { isActive: ["active", "isActive"], isFirst: ["first", "isFirst"] }, outputs: { clicked: "clicked" }, ngContentSelectors: _c1$1, decls: 2, vars: 6, consts: [[1, "cup-bracket-selector__button", 3, "disabled", "ngClass", "click"]], template: function CupBracketSelectorButtonComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "button", 0);
        i0.ɵɵlistener("click", function CupBracketSelectorButtonComponent_Template_button_click_0_listener() { return ctx.clicked.emit(); });
        i0.ɵɵprojection(1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("disabled", ctx.isActive)("ngClass", i0.ɵɵpureFunction3(2, _c0$6, ctx.isActive, ctx.isFirst, !ctx.isFirst));
    } }, directives: [i2.NgClass], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CupBracketSelectorButtonComponent, [{
        type: Component,
        args: [{
                selector: "cup-bracket-selector-button",
                templateUrl: "./cup-bracket-selector-button.component.html",
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, { isActive: [{
            type: Input,
            args: ["active"]
        }], isFirst: [{
            type: Input,
            args: ["first"]
        }], clicked: [{
            type: Output
        }] }); })();

function CupBracketSelectorComponent_cup_bracket_selector_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cup-bracket-selector-button", 3);
    i0.ɵɵlistener("clicked", function CupBracketSelectorComponent_cup_bracket_selector_button_1_Template_cup_bracket_selector_button_clicked_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return ctx_r3.selectIndex(ctx_r3.bracketIndex.UPPER_BRACKET); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("active", ctx_r0.selectedBracket === ctx_r0.bracketIndex.UPPER_BRACKET)("first", ctx_r0.isDoubleElimination || ctx_r0.hasThirdPlaceMatch);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 3, "cup-bracket-selector:upper-bracket"), " ");
} }
function CupBracketSelectorComponent_cup_bracket_selector_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cup-bracket-selector-button", 4);
    i0.ɵɵlistener("clicked", function CupBracketSelectorComponent_cup_bracket_selector_button_2_Template_cup_bracket_selector_button_clicked_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.selectIndex(ctx_r5.bracketIndex.LOWER_BRACKET); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("active", ctx_r1.selectedBracket === ctx_r1.bracketIndex.LOWER_BRACKET);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "cup-bracket-selector:lower-bracket"), " ");
} }
function CupBracketSelectorComponent_cup_bracket_selector_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cup-bracket-selector-button", 4);
    i0.ɵɵlistener("clicked", function CupBracketSelectorComponent_cup_bracket_selector_button_3_Template_cup_bracket_selector_button_clicked_0_listener() { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(); return ctx_r7.selectIndex(ctx_r7.bracketIndex.THIRD_PLACE); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("active", ctx_r2.selectedBracket === ctx_r2.bracketIndex.LOWER_BRACKET);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "cup-bracket-selector:third-place-match"), " ");
} }
var BracketIndex;
(function (BracketIndex) {
    BracketIndex[BracketIndex["UPER_BRACKET"] = 0] = "UPER_BRACKET";
    BracketIndex[BracketIndex["LOWER_BRACKET"] = 1] = "LOWER_BRACKET";
})(BracketIndex || (BracketIndex = {}));
var BracketIndexType;
(function (BracketIndexType) {
    BracketIndexType[BracketIndexType["UPPER_BRACKET"] = 0] = "UPPER_BRACKET";
    BracketIndexType[BracketIndexType["LOWER_BRACKET"] = 1] = "LOWER_BRACKET";
    BracketIndexType[BracketIndexType["THIRD_PLACE"] = 2] = "THIRD_PLACE";
})(BracketIndexType || (BracketIndexType = {}));
class CupBracketSelectorComponent {
    constructor() {
        this.selected = new EventEmitter();
        this.bracketIndex = BracketIndexType;
    }
    selectIndex(bracket) {
        const index = bracket === BracketIndexType.UPPER_BRACKET ? BracketIndex.UPER_BRACKET : BracketIndex.LOWER_BRACKET;
        this.selected.emit(index);
    }
}
CupBracketSelectorComponent.ɵfac = function CupBracketSelectorComponent_Factory(t) { return new (t || CupBracketSelectorComponent)(); };
CupBracketSelectorComponent.ɵcmp = i0.ɵɵdefineComponent({ type: CupBracketSelectorComponent, selectors: [["cup-bracket-selector"]], inputs: { isDoubleElimination: "isDoubleElimination", hasThirdPlaceMatch: "hasThirdPlaceMatch", selectedBracket: "selectedBracket" }, outputs: { selected: "selected" }, decls: 4, vars: 3, consts: [[1, "cup-bracket-selector"], [3, "active", "first", "clicked", 4, "ngIf"], [3, "active", "clicked", 4, "ngIf"], [3, "active", "first", "clicked"], [3, "active", "clicked"]], template: function CupBracketSelectorComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "article", 0);
        i0.ɵɵtemplate(1, CupBracketSelectorComponent_cup_bracket_selector_button_1_Template, 3, 5, "cup-bracket-selector-button", 1);
        i0.ɵɵtemplate(2, CupBracketSelectorComponent_cup_bracket_selector_button_2_Template, 3, 4, "cup-bracket-selector-button", 2);
        i0.ɵɵtemplate(3, CupBracketSelectorComponent_cup_bracket_selector_button_3_Template, 3, 4, "cup-bracket-selector-button", 2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isDoubleElimination || ctx.hasThirdPlaceMatch);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isDoubleElimination);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.hasThirdPlaceMatch);
    } }, directives: [i2.NgIf, CupBracketSelectorButtonComponent], pipes: [i3.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CupBracketSelectorComponent, [{
        type: Component,
        args: [{
                selector: "cup-bracket-selector",
                templateUrl: "./cup-bracket-selector.component.html",
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, { isDoubleElimination: [{
            type: Input
        }], hasThirdPlaceMatch: [{
            type: Input
        }], selectedBracket: [{
            type: Input
        }], selected: [{
            type: Output
        }] }); })();

const _c0$5 = ["*"];
class CupBracketNavigationRoundComponent extends InheritClassComponent {
}
CupBracketNavigationRoundComponent.ɵfac = function CupBracketNavigationRoundComponent_Factory(t) { return ɵCupBracketNavigationRoundComponent_BaseFactory(t || CupBracketNavigationRoundComponent); };
CupBracketNavigationRoundComponent.ɵcmp = i0.ɵɵdefineComponent({ type: CupBracketNavigationRoundComponent, selectors: [["cup-bracket-navigation-round"]], features: [i0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c0$5, decls: 2, vars: 0, consts: [[1, "cup-bracket-navigation__rounds__round"]], template: function CupBracketNavigationRoundComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵprojection(1);
        i0.ɵɵelementEnd();
    } }, styles: ["[_nghost-%COMP%] {\n                display: flex;\n                align-content: stretch;\n            }"], changeDetection: 0 });
const ɵCupBracketNavigationRoundComponent_BaseFactory = /*@__PURE__*/ i0.ɵɵgetInheritedFactory(CupBracketNavigationRoundComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CupBracketNavigationRoundComponent, [{
        type: Component,
        args: [{
                selector: "cup-bracket-navigation-round",
                templateUrl: "./cup-bracket-navigation-round.component.html",
                styles: [
                    `
            :host {
                display: flex;
                align-content: stretch;
            }
        `,
                ],
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, null); })();

class CupMyPositionButtonComponent {
    constructor() {
        this.clicked = new EventEmitter();
    }
}
CupMyPositionButtonComponent.ɵfac = function CupMyPositionButtonComponent_Factory(t) { return new (t || CupMyPositionButtonComponent)(); };
CupMyPositionButtonComponent.ɵcmp = i0.ɵɵdefineComponent({ type: CupMyPositionButtonComponent, selectors: [["cup-my-position-button"]], outputs: { clicked: "clicked" }, decls: 3, vars: 3, consts: [[1, "cup-my-position-button", 3, "click"]], template: function CupMyPositionButtonComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "button", 0);
        i0.ɵɵlistener("click", function CupMyPositionButtonComponent_Template_button_click_0_listener() { return ctx.clicked.emit(); });
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "cup-my-position-button:my-position"), "\n");
    } }, pipes: [i3.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CupMyPositionButtonComponent, [{
        type: Component,
        args: [{
                selector: "cup-my-position-button",
                templateUrl: "./cup-my-position-button.component.html",
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, { clicked: [{
            type: Output
        }] }); })();

const HighlightedContestantActionTypes = {
    SET_CONTESTANT: type("[Cup Bracket] Set Highlighted Contestant"),
};
class SetHighlightedContestantAction {
    constructor(contestantId) {
        this.contestantId = contestantId;
        this.type = HighlightedContestantActionTypes.SET_CONTESTANT;
    }
    get payload() {
        return this.contestantId;
    }
}
const reducers = queueReducers([
    (state = null, action) => {
        if (action.type === HighlightedContestantActionTypes.SET_CONTESTANT) {
            return action.payload;
        }
    },
]);
function highlightedContestantReducer(state, action) {
    return reducers(state, action);
}
function getHighlightedContestant(state) {
    return state.cupBracket.highlightedContestant;
}

const _c0$4 = ["*"];
class CupMatchLinkComponent {
    constructor(linkService) {
        this.linkService = linkService;
    }
    ngOnChanges(changes) {
        this.matchUrl = this.linkService.match(this.leagueUri, this.matchId);
    }
}
CupMatchLinkComponent.ɵfac = function CupMatchLinkComponent_Factory(t) { return new (t || CupMatchLinkComponent)(i0.ɵɵdirectiveInject(i1.LinkService)); };
CupMatchLinkComponent.ɵcmp = i0.ɵɵdefineComponent({ type: CupMatchLinkComponent, selectors: [["cup-match-link"]], inputs: { leagueUri: "leagueUri", matchId: "matchId" }, features: [i0.ɵɵNgOnChangesFeature], ngContentSelectors: _c0$4, decls: 2, vars: 1, consts: [[3, "locationHref"]], template: function CupMatchLinkComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "a", 0);
        i0.ɵɵprojection(1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("locationHref", ctx.matchUrl);
    } }, directives: [i1.LocationDirective], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CupMatchLinkComponent, [{
        type: Component,
        args: [{
                selector: "cup-match-link",
                templateUrl: "./cup-match-link.component.html",
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i1.LinkService }]; }, { leagueUri: [{
            type: Input
        }], matchId: [{
            type: Input
        }] }); })();

const _c0$3 = ["*"];
class CupContestantLinkComponent {
    constructor(linkService) {
        this.linkService = linkService;
    }
    ngOnChanges(changes) {
        if (this.isTeam) {
            this.contestantUrl = this.linkService.teamContestant(this.leagueUri, this.isRoster, this.contestant.id);
        }
        else {
            this.contestantUrl = this.linkService.player(this.contestant.id, this.contestant.alias);
        }
    }
}
CupContestantLinkComponent.ɵfac = function CupContestantLinkComponent_Factory(t) { return new (t || CupContestantLinkComponent)(i0.ɵɵdirectiveInject(i1.LinkService)); };
CupContestantLinkComponent.ɵcmp = i0.ɵɵdefineComponent({ type: CupContestantLinkComponent, selectors: [["cup-contestant-link"]], inputs: { isRoster: "isRoster", isTeam: "isTeam", leagueUri: "leagueUri", contestant: "contestant" }, features: [i0.ɵɵNgOnChangesFeature], ngContentSelectors: _c0$3, decls: 2, vars: 2, consts: [[3, "locationHref", "title"]], template: function CupContestantLinkComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "a", 0);
        i0.ɵɵprojection(1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("locationHref", ctx.contestantUrl)("title", ctx.contestant.name);
    } }, directives: [i1.LocationDirective], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CupContestantLinkComponent, [{
        type: Component,
        args: [{
                selector: "cup-contestant-link",
                templateUrl: "./cup-contestant-link.component.html",
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i1.LinkService }]; }, { isRoster: [{
            type: Input
        }], isTeam: [{
            type: Input
        }], leagueUri: [{
            type: Input
        }], contestant: [{
            type: Input
        }] }); })();

function CupMatchParticipantComponent_country_flag_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "country-flag", 6);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("country", ctx_r0.participant.region);
} }
function CupMatchParticipantComponent_ng_container_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "cup-match-participant:tbd"), " ");
} }
function CupMatchParticipantComponent_ng_container_4_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "cup-match-participant:defwin"), " ");
} }
function CupMatchParticipantComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CupMatchParticipantComponent_ng_container_4_ng_container_1_Template, 3, 3, "ng-container", 4);
    i0.ɵɵtemplate(2, CupMatchParticipantComponent_ng_container_4_ng_container_2_Template, 3, 3, "ng-container", 4);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.matchState !== "closed");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.matchState === "closed");
} }
function CupMatchParticipantComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "cup-contestant-link", 7);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("contestant", ctx_r2.participant)("isTeam", ctx_r2.isTeam)("isRoster", ctx_r2.isRoster)("leagueUri", ctx_r2.leagueUri);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.participant.name, " ");
} }
function CupMatchParticipantComponent_premium_badge_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "premium-badge");
} }
function CupMatchParticipantComponent_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, " - ");
    i0.ɵɵelementContainerEnd();
} }
function CupMatchParticipantComponent_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r5.score, " ");
} }
class CupMatchParticipantComponent {
    ngOnChanges(changes) {
        this.matchParticipantClassList = this.getMatchParticipantClassList();
        this.scoreClassList = this.getScoreClassList();
    }
    getScoreClassList() {
        const classList = [];
        if (this.isWin) {
            classList.push("is-win");
        }
        if (this.isLoss) {
            classList.push("is-loss");
        }
        return classList.join(" ");
    }
    getMatchParticipantClassList() {
        const classList = [];
        if (this.isWin) {
            classList.push("is-win");
        }
        return classList.join(" ");
    }
}
CupMatchParticipantComponent.ɵfac = function CupMatchParticipantComponent_Factory(t) { return new (t || CupMatchParticipantComponent)(); };
CupMatchParticipantComponent.ɵcmp = i0.ɵɵdefineComponent({ type: CupMatchParticipantComponent, selectors: [["cup-match-participant"]], inputs: { isRoster: "isRoster", isTeam: "isTeam", isWin: "isWin", isLoss: "isLoss", leagueUri: "leagueUri", participant: "participant", participantDetails: "participantDetails", matchState: "matchState", score: "score" }, features: [i0.ɵɵNgOnChangesFeature], decls: 10, vars: 8, consts: [[1, "cup-match__result__player", 3, "ngClass"], ["class", "cup-match__result__player__flag", 3, "country", 4, "ngIf"], [1, "cup-match__result__player__name"], [1, "cup-match__result__player__name-wrapper"], [4, "ngIf"], [1, "cup-match__result__player__score", 3, "ngClass"], [1, "cup-match__result__player__flag", 3, "country"], [1, "cup-match__result__player__name-inner", 3, "contestant", "isTeam", "isRoster", "leagueUri"]], template: function CupMatchParticipantComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, CupMatchParticipantComponent_country_flag_1_Template, 1, 1, "country-flag", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵtemplate(4, CupMatchParticipantComponent_ng_container_4_Template, 3, 2, "ng-container", 4);
        i0.ɵɵtemplate(5, CupMatchParticipantComponent_ng_container_5_Template, 3, 5, "ng-container", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(6, CupMatchParticipantComponent_premium_badge_6_Template, 1, 0, "premium-badge", 4);
        i0.ɵɵelementStart(7, "div", 5);
        i0.ɵɵtemplate(8, CupMatchParticipantComponent_ng_container_8_Template, 2, 0, "ng-container", 4);
        i0.ɵɵtemplate(9, CupMatchParticipantComponent_ng_container_9_Template, 2, 1, "ng-container", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", ctx.matchParticipantClassList);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.participant);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", !ctx.participant);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.participant);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.participantDetails == null ? null : ctx.participantDetails.premium);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", ctx.scoreClassList);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.score === null);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.score !== null);
    } }, directives: [i2.NgClass, i2.NgIf, i1.CountryFlagComponent, CupContestantLinkComponent, i4.PremiumBadgeComponent], pipes: [i3.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CupMatchParticipantComponent, [{
        type: Component,
        args: [{
                selector: "cup-match-participant",
                templateUrl: "./cup-match-participant.component.html",
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, { isRoster: [{
            type: Input
        }], isTeam: [{
            type: Input
        }], isWin: [{
            type: Input
        }], isLoss: [{
            type: Input
        }], leagueUri: [{
            type: Input
        }], participant: [{
            type: Input
        }], participantDetails: [{
            type: Input
        }], matchState: [{
            type: Input
        }], score: [{
            type: Input
        }] }); })();

function CupMatchComponent_ng_container_0_div_2_div_1_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const participant_r5 = i0.ɵɵnextContext().$implicit;
    const ctx_r6 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.participants[participant_r5.id] == null ? null : ctx_r6.participants[participant_r5.id].seed, " ");
} }
function CupMatchComponent_ng_container_0_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtemplate(1, CupMatchComponent_ng_container_0_div_2_div_1_span_1_Template, 2, 1, "span", 0);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const participant_r5 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.participants[participant_r5.id]);
} }
function CupMatchComponent_ng_container_0_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtemplate(1, CupMatchComponent_ng_container_0_div_2_div_1_Template, 2, 1, "div", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r2.match.participants);
} }
function CupMatchComponent_ng_container_0_cup_match_participant_4_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cup-match-participant", 10);
    i0.ɵɵlistener("mouseenter", function CupMatchComponent_ng_container_0_cup_match_participant_4_Template_cup_match_participant_mouseenter_0_listener() { i0.ɵɵrestoreView(_r10); const participant_r8 = ctx.$implicit; const ctx_r9 = i0.ɵɵnextContext(2); return ctx_r9.setHighlightedContestant(participant_r8.id); })("mouseleave", function CupMatchComponent_ng_container_0_cup_match_participant_4_Template_cup_match_participant_mouseleave_0_listener() { i0.ɵɵrestoreView(_r10); const ctx_r11 = i0.ɵɵnextContext(2); return ctx_r11.setHighlightedContestant(null); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const participant_r8 = ctx.$implicit;
    const participantsDetails_r1 = i0.ɵɵnextContext().ngIf;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("participant", ctx_r3.participants[participant_r8.id])("participantDetails", participantsDetails_r1[participant_r8.id])("score", ctx_r3.scores[participant_r8.id])("matchState", ctx_r3.match.state)("leagueUri", ctx_r3.league.uri)("isRoster", ctx_r3.isRoster)("isTeam", ctx_r3.isTeam)("isWin", participant_r8.place === 1)("isLoss", participant_r8.place > 1);
} }
function CupMatchComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "article", 1);
    i0.ɵɵtemplate(2, CupMatchComponent_ng_container_0_div_2_Template, 2, 1, "div", 2);
    i0.ɵɵelementStart(3, "div", 3);
    i0.ɵɵtemplate(4, CupMatchComponent_ng_container_0_cup_match_participant_4_Template, 1, 9, "cup-match-participant", 4);
    i0.ɵɵelementStart(5, "cup-match-link", 5);
    i0.ɵɵelementStart(6, "span", 6);
    i0.ɵɵtext(7, "VS");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r0.matchClassList);
    i0.ɵɵattribute("data-id", ctx_r0.match.id);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showSeeds);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.match.participants);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matchId", ctx_r0.match.id)("leagueUri", ctx_r0.league.uri);
} }
class CupMatchComponent {
    constructor(store) {
        this.store = store;
    }
    setHighlightedContestant(contestantId) {
        this.store.dispatch(new SetHighlightedContestantAction(contestantId));
    }
    ngOnChanges(changes) {
        this.matchClassList = this.getMatchClassList();
        this.scores = this.match.participants.reduce((scores, participant) => {
            scores[participant.id] = this.getBestOfScore(participant.points);
            return scores;
        }, {});
        const playerIds = this.match.participants.map(({ id }) => id).filter(id => id > 0);
        if (playerIds.length) {
            if (this.isTeam) {
                this.store.dispatch(new LoadTeamsOnceAction(playerIds));
                this.participantsDetails$ = this.store.select(getTeams(playerIds)).pipe(teamsToDictionary());
            }
            else {
                this.store.dispatch(new LoadPlayersOnceAction(playerIds));
                this.participantsDetails$ = this.store.select(getPlayers(playerIds)).pipe(playersToDictionary());
            }
        }
        else {
            this.participantsDetails$ = of({});
        }
    }
    getBestOfScore(score) {
        if (!score || !score.length) {
            return null;
        }
        return reduce(score, function (sum, n) {
            return sum + n;
        }, 0);
    }
    getMatchClassList() {
        const classList = [];
        if (this.isSelf) {
            classList.push("cup-match--self");
        }
        if (this.isFollowing) {
            classList.push("cup-match--following");
        }
        if (this.isHighlighted) {
            classList.push("cup-match--highlight");
        }
        return classList.join(" ");
    }
}
CupMatchComponent.ɵfac = function CupMatchComponent_Factory(t) { return new (t || CupMatchComponent)(i0.ɵɵdirectiveInject(i1$1.Store)); };
CupMatchComponent.ɵcmp = i0.ɵɵdefineComponent({ type: CupMatchComponent, selectors: [["cup-match"]], inputs: { isTeam: "isTeam", isRoster: "isRoster", league: "league", participants: "participants", ownContestant: "ownContestant", selectedParticipant: "selectedParticipant", match: "match", showSeeds: "showSeeds", isSelf: "isSelf", isFollowing: "isFollowing", isHighlighted: "isHighlighted" }, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 3, consts: [[4, "ngIf"], [1, "cup-match", 3, "ngClass"], ["class", "cup-match__seeds", 4, "ngIf"], [1, "cup-match__result"], [3, "participant", "participantDetails", "score", "matchState", "leagueUri", "isRoster", "isTeam", "isWin", "isLoss", "mouseenter", "mouseleave", 4, "ngFor", "ngForOf"], [3, "matchId", "leagueUri"], [1, "cup-match__result__vs"], [1, "cup-match__seeds"], ["class", "cup-match__seeds__seed", 4, "ngFor", "ngForOf"], [1, "cup-match__seeds__seed"], [3, "participant", "participantDetails", "score", "matchState", "leagueUri", "isRoster", "isTeam", "isWin", "isLoss", "mouseenter", "mouseleave"]], template: function CupMatchComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, CupMatchComponent_ng_container_0_Template, 8, 6, "ng-container", 0);
        i0.ɵɵpipe(1, "async");
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.participantsDetails$));
    } }, directives: [i2.NgIf, i2.NgClass, i2.NgForOf, CupMatchLinkComponent, CupMatchParticipantComponent], pipes: [i2.AsyncPipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CupMatchComponent, [{
        type: Component,
        args: [{
                selector: "cup-match",
                templateUrl: "./cup-match.component.html",
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i1$1.Store }]; }, { isTeam: [{
            type: Input
        }], isRoster: [{
            type: Input
        }], league: [{
            type: Input
        }], participants: [{
            type: Input
        }], ownContestant: [{
            type: Input
        }], selectedParticipant: [{
            type: Input
        }], match: [{
            type: Input
        }], showSeeds: [{
            type: Input
        }], isSelf: [{
            type: Input
        }], isFollowing: [{
            type: Input
        }], isHighlighted: [{
            type: Input
        }] }); })();

function CupRoundComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵelement(2, "cup-match", 3);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const match_r1 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpipeBind1(1, 12, ctx_r0.getRoundClasses(match_r1)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("league", ctx_r0.league)("participants", ctx_r0.participants)("selectedParticipant", ctx_r0.selectedParticipant)("ownContestant", ctx_r0.ownContestant)("match", match_r1)("isTeam", ctx_r0.isTeam)("isRoster", ctx_r0.isRoster)("isSelf", ctx_r0.isContestantInMatch(match_r1, ctx_r0.ownContestant))("isFollowing", ctx_r0.isContestantInMatch(match_r1, ctx_r0.selectedParticipant))("isHighlighted", i0.ɵɵpipeBind1(3, 14, ctx_r0.isMatchHighlighted(match_r1)))("showSeeds", ctx_r0.showSeeds);
} }
class CupRoundComponent {
    constructor(store) {
        this.store = store;
    }
    ngOnChanges(changes) {
        this.bracketRoundClassList = this.getBracketRoundClassList();
        this.isTeam = isTeam(this.league);
        this.isRoster = isRosterEnabled(this.league);
    }
    getBracketRoundClassList() {
        const classList = [];
        if (this.isFirst) {
            classList.push("cup-rounds__round--first");
        }
        if (this.isLast || (this.isFinal && this.league.cupMode === "double_double_final")) {
            classList.push("cup-rounds__round--last");
        }
        return classList.join(" ");
    }
    isContestantInMatch(match, contestanId) {
        if (!contestanId) {
            return false;
        }
        return findIndex(match.participants, { id: +contestanId }) !== -1;
    }
    isMatchHighlighted(match) {
        return this.store.select(getHighlightedContestant).pipe(map(id => this.isContestantInMatch(match, id)));
    }
    getRoundClasses(match) {
        const classList = {
            "cup-match-wrapper--self": this.ownContestant && this.isContestantInMatch(match, this.ownContestant),
            "cup-match-wrapper--self-came-upper": this.ownContestant && match.participants[0].id === this.ownContestant,
            "cup-match-wrapper--self-came-lower": this.ownContestant && match.participants[1].id === this.ownContestant,
            "cup-match-wrapper--following": this.selectedParticipant && this.isContestantInMatch(match, this.selectedParticipant),
            "cup-match-wrapper--following-came-upper": this.selectedParticipant && match.participants[0].id === this.selectedParticipant,
            "cup-match-wrapper--following-came-lower": this.selectedParticipant && match.participants[1].id === this.selectedParticipant,
            "cup-match-wrapper--double-final": this.isDoubleElimination && this.isFinal,
        };
        return combineLatest(this.isMatchHighlighted(match), this.store.select(getHighlightedContestant)).pipe(map(([condition, contestantId]) => (Object.assign(Object.assign({}, classList), { "cup-match-wrapper--highlight": condition, "cup-match-wrapper--highlight-came-upper": condition && match.participants[0].id === contestantId, "cup-match-wrapper--highlight-came-lower": condition && match.participants[1].id === contestantId }))));
    }
    trackMatch(index, match) {
        return match.id;
    }
}
CupRoundComponent.ɵfac = function CupRoundComponent_Factory(t) { return new (t || CupRoundComponent)(i0.ɵɵdirectiveInject(i1$1.Store)); };
CupRoundComponent.ɵcmp = i0.ɵɵdefineComponent({ type: CupRoundComponent, selectors: [["cup-round"]], inputs: { round: "round", league: "league", ownContestant: "ownContestant", selectedParticipant: "selectedParticipant", participants: "participants", isDoubleElimination: "isDoubleElimination", showSeeds: "showSeeds", isFinal: "isFinal", isFirst: "isFirst", isLast: "isLast" }, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 3, consts: [[1, "cup-rounds__round", 3, "ngClass"], ["class", "cup-match-container cup-match-wrapper", 3, "ngClass", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "cup-match-container", "cup-match-wrapper", 3, "ngClass"], [3, "league", "participants", "selectedParticipant", "ownContestant", "match", "isTeam", "isRoster", "isSelf", "isFollowing", "isHighlighted", "showSeeds"]], template: function CupRoundComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, CupRoundComponent_div_1_Template, 4, 16, "div", 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", ctx.bracketRoundClassList);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.round)("ngForTrackBy", ctx.trackMatch);
    } }, directives: [i2.NgClass, i2.NgForOf, CupMatchComponent], pipes: [i2.AsyncPipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CupRoundComponent, [{
        type: Component,
        args: [{
                selector: "cup-round",
                templateUrl: "./cup-round.component.html",
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i1$1.Store }]; }, { round: [{
            type: Input
        }], league: [{
            type: Input
        }], ownContestant: [{
            type: Input
        }], selectedParticipant: [{
            type: Input
        }], participants: [{
            type: Input
        }], isDoubleElimination: [{
            type: Input
        }], showSeeds: [{
            type: Input
        }], isFinal: [{
            type: Input
        }], isFirst: [{
            type: Input
        }], isLast: [{
            type: Input
        }] }); })();

function CupLowerBracketRoundComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵelement(2, "cup-match", 3);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const match_r1 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpipeBind1(1, 11, ctx_r0.getRoundClasses(match_r1)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("league", ctx_r0.league)("participants", ctx_r0.participants)("selectedParticipant", ctx_r0.selectedParticipant)("ownContestant", ctx_r0.ownContestant)("match", match_r1)("isTeam", ctx_r0.isTeam)("isRoster", ctx_r0.isRoster)("isSelf", ctx_r0.isContestantInMatch(match_r1, ctx_r0.ownContestant))("isFollowing", ctx_r0.isContestantInMatch(match_r1, ctx_r0.selectedParticipant))("isHighlighted", i0.ɵɵpipeBind1(3, 13, ctx_r0.isMatchHighlighted(match_r1)));
} }
class CupLowerBracketRoundComponent {
    constructor(store) {
        this.store = store;
    }
    ngOnChanges(changes) {
        this.bracketRoundClassList = this.getBracketRoundClassList();
        this.isTeam = isTeam(this.league);
        this.isRoster = isRosterEnabled(this.league);
    }
    getBracketRoundClassList() {
        const classList = [];
        if (this.isFirst) {
            classList.push("cup-rounds__round--first");
        }
        if (this.isLast) {
            classList.push("cup-rounds__round--last");
        }
        return classList.join(" ");
    }
    isContestantInMatch(match, contestanId) {
        if (!contestanId) {
            return false;
        }
        return findIndex(match.participants, { id: +contestanId }) !== -1;
    }
    isMatchHighlighted(match) {
        return this.store.select(getHighlightedContestant).pipe(map(id => this.isContestantInMatch(match, id)));
    }
    getRoundClasses(match) {
        const classList = {
            "cup-rounds__round__item--receiver": this.isReceiver,
            "cup-rounds__round__item--no-lines": this.isFirst,
            "cup-rounds__round__item--self": this.ownContestant && this.isContestantInMatch(match, this.ownContestant),
            "cup-rounds__round__item--following": this.isContestantInMatch(match, this.selectedParticipant),
            "cup-rounds__round__item--following-came-upper": this.selectedParticipant && match.participants[0].id === this.selectedParticipant,
            "cup-rounds__round__item--following-came-lower": this.selectedParticipant && match.participants[1].id === this.selectedParticipant,
            "cup-rounds__round__item--self-came-upper": this.ownContestant && match.participants[0].id === this.ownContestant,
            "cup-rounds__round__item--self-came-lower": this.ownContestant && match.participants[1].id === this.ownContestant,
        };
        return combineLatest(this.isMatchHighlighted(match), this.store.select(getHighlightedContestant)).pipe(map(([condition, contestantId]) => (Object.assign(Object.assign({}, classList), { "cup-rounds__round__item--highlight": condition, "cup-rounds__round__item--highlight-came-upper": condition && match.participants[0].id === contestantId, "cup-rounds__round__item--highlight-came-lower": condition && match.participants[1].id === contestantId }))));
    }
    trackMatch(index, match) {
        return match.id;
    }
}
CupLowerBracketRoundComponent.ɵfac = function CupLowerBracketRoundComponent_Factory(t) { return new (t || CupLowerBracketRoundComponent)(i0.ɵɵdirectiveInject(i1$1.Store)); };
CupLowerBracketRoundComponent.ɵcmp = i0.ɵɵdefineComponent({ type: CupLowerBracketRoundComponent, selectors: [["cup-lower-bracket-round"]], inputs: { round: "round", league: "league", ownContestant: "ownContestant", selectedParticipant: "selectedParticipant", participants: "participants", isFirst: "isFirst", isLast: "isLast", isReceiver: "isReceiver" }, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 3, consts: [[1, "cup-rounds__round", "cup-rounds__round--lower", "cup-rounds__round--receiver", 3, "ngClass"], ["class", "cup-rounds__round__item--lower-bracket", 3, "ngClass", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "cup-rounds__round__item--lower-bracket", 3, "ngClass"], [3, "league", "participants", "selectedParticipant", "ownContestant", "match", "isTeam", "isRoster", "isSelf", "isFollowing", "isHighlighted"]], template: function CupLowerBracketRoundComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, CupLowerBracketRoundComponent_div_1_Template, 4, 15, "div", 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", ctx.bracketRoundClassList);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.round)("ngForTrackBy", ctx.trackMatch);
    } }, directives: [i2.NgClass, i2.NgForOf, CupMatchComponent], pipes: [i2.AsyncPipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CupLowerBracketRoundComponent, [{
        type: Component,
        args: [{
                selector: "cup-lower-bracket-round",
                templateUrl: "./cup-lower-bracket-round.component.html",
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i1$1.Store }]; }, { round: [{
            type: Input
        }], league: [{
            type: Input
        }], ownContestant: [{
            type: Input
        }], selectedParticipant: [{
            type: Input
        }], participants: [{
            type: Input
        }], isFirst: [{
            type: Input
        }], isLast: [{
            type: Input
        }], isReceiver: [{
            type: Input
        }] }); })();

const _c0$2 = function (a0) { return { "cup-rounds__lower-bracket-round-container--receiver": a0 }; };
function CupLowerBracketComponent_cup_lower_bracket_round_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "cup-lower-bracket-round", 3);
} if (rf & 2) {
    const round_r2 = ctx.$implicit;
    const $index_r3 = ctx.index;
    const $first_r4 = ctx.first;
    const $last_r5 = ctx.last;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("round", round_r2)("league", ctx_r0.league)("ownContestant", ctx_r0.ownContestant)("participants", ctx_r0.participants)("selectedParticipant", ctx_r0.selectedParticipant)("isFirst", $first_r4)("isLast", $last_r5)("isReceiver", ctx_r0.isReceiver(ctx_r0.rounds, $index_r3))("ngClass", i0.ɵɵpureFunction1(9, _c0$2, !ctx_r0.isReceiver(ctx_r0.rounds, $index_r3)));
} }
function CupLowerBracketComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 4);
} }
class CupLowerBracketComponent {
    ngOnChanges(changes) {
        this.placeHolderRounds = range(0, Math.max(0, this.roundDisplayAmount - this.rounds.length));
    }
    isEvenRound(round) {
        return this.rounds.indexOf(round) % 2 === 0;
    }
    isReceiver(allRounds, roundIndex) {
        const currentRound = allRounds[roundIndex];
        const previousRound = allRounds[roundIndex - 1];
        const nextRound = allRounds[roundIndex + 1];
        if (nextRound) {
            return nextRound.length < currentRound.length;
        }
        if (previousRound) {
            return previousRound.length === currentRound.length;
        }
        return false;
    }
    trackRound(index, round) {
        return index;
    }
}
CupLowerBracketComponent.ɵfac = function CupLowerBracketComponent_Factory(t) { return new (t || CupLowerBracketComponent)(); };
CupLowerBracketComponent.ɵcmp = i0.ɵɵdefineComponent({ type: CupLowerBracketComponent, selectors: [["cup-lower-bracket"]], inputs: { rounds: "rounds", roundOffset: "roundOffset", roundDisplayAmount: "roundDisplayAmount", league: "league", ownContestant: "ownContestant", selectedParticipant: "selectedParticipant", participants: "participants" }, features: [i0.ɵɵNgOnChangesFeature], decls: 3, vars: 4, consts: [[1, "cup-bracket", "cup-rounds", "cup-rounds--lower-bracket"], ["class", "flex cup-rounds__lower-bracket-round-container", 3, "round", "league", "ownContestant", "participants", "selectedParticipant", "isFirst", "isLast", "isReceiver", "ngClass", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["class", "cup-rounds__round cup-rounds__round--placeholder", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "flex", "cup-rounds__lower-bracket-round-container", 3, "round", "league", "ownContestant", "participants", "selectedParticipant", "isFirst", "isLast", "isReceiver", "ngClass"], [1, "cup-rounds__round", "cup-rounds__round--placeholder"]], template: function CupLowerBracketComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "article", 0);
        i0.ɵɵtemplate(1, CupLowerBracketComponent_cup_lower_bracket_round_1_Template, 1, 11, "cup-lower-bracket-round", 1);
        i0.ɵɵtemplate(2, CupLowerBracketComponent_div_2_Template, 1, 0, "div", 2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.rounds)("ngForTrackBy", ctx.trackRound);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.placeHolderRounds)("ngForTrackBy", ctx.trackRound);
    } }, directives: [i2.NgForOf, CupLowerBracketRoundComponent, i2.NgClass], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CupLowerBracketComponent, [{
        type: Component,
        args: [{
                selector: "cup-lower-bracket",
                templateUrl: "./cup-lower-bracket.component.html",
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, { rounds: [{
            type: Input
        }], roundOffset: [{
            type: Input
        }], roundDisplayAmount: [{
            type: Input
        }], league: [{
            type: Input
        }], ownContestant: [{
            type: Input
        }], selectedParticipant: [{
            type: Input
        }], participants: [{
            type: Input
        }] }); })();

function CupUpperBracketComponent_ng_container_1_cup_round_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "cup-round", 4);
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    const round_r2 = ctx_r7.$implicit;
    const $first_r4 = ctx_r7.first;
    const $last_r5 = ctx_r7.last;
    const $index_r3 = ctx_r7.index;
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("round", round_r2)("league", ctx_r6.league)("ownContestant", ctx_r6.ownContestant)("participants", ctx_r6.participants)("selectedParticipant", ctx_r6.selectedParticipant)("isFirst", $first_r4)("isLast", $last_r5)("isDoubleElimination", ctx_r6.isDoubleElimination)("isFinal", ctx_r6.isFinalRound(ctx_r6.rounds, $index_r3))("showSeeds", ctx_r6.roundOffset === 0 && $first_r4 && !ctx_r6.isThirdPlaceRound($index_r3));
} }
function CupUpperBracketComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CupUpperBracketComponent_ng_container_1_cup_round_1_Template, 1, 10, "cup-round", 3);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const round_r2 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.filterException(round_r2));
} }
function CupUpperBracketComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 5);
} }
class CupUpperBracketComponent {
    ngOnChanges(changes) {
        this.placeHolderRounds = range(0, Math.max(0, this.roundDisplayAmount - this.rounds.length));
    }
    /**
     * @param rounds All displayed rounds of the upper bracket.
     * @param roundIndex  The index of round to check.
     *
     * @returns boolean True if round is last round within Bracket.
     */
    isFinalRound(rounds, roundIndex) {
        const currentRound = rounds[roundIndex];
        const previousRound = rounds[roundIndex - 1];
        const nextRound = rounds[roundIndex + 1];
        if (this.league.cupMode === "double_double_final" &&
            last(rounds) === nextRound &&
            nextRound[0] &&
            nextRound[0].state === "cancelled") {
            return true;
        }
        if (this.league.cupMode !== "double_double_final") {
            if (!(last(rounds) === currentRound)) {
                return false;
            }
        }
        if (!previousRound) {
            return false;
        }
        if (currentRound) {
            if (currentRound.length !== previousRound.length) {
                return false;
            }
        }
        return true;
    }
    /**
     * @param roundIndex The index of round to check.
     *
     * @return boolean Trie if round is the third place round
     */
    isThirdPlaceRound(roundIndex) {
        const match = sample(this.rounds[roundIndex]);
        return match && match.bracket === 1;
    }
    trackRound(index, round) {
        return index;
    }
    filterException(round) {
        /**
         * Check for cancelled final #2 in a DoubleDouble Final league.
         */
        if (this.league.cupMode === "double_double_final" && last(this.rounds) === round && round[0] && round[0].state === "cancelled") {
            return false;
        }
        return true;
    }
}
CupUpperBracketComponent.ɵfac = function CupUpperBracketComponent_Factory(t) { return new (t || CupUpperBracketComponent)(); };
CupUpperBracketComponent.ɵcmp = i0.ɵɵdefineComponent({ type: CupUpperBracketComponent, selectors: [["cup-upper-bracket"]], inputs: { rounds: "rounds", roundOffset: "roundOffset", roundDisplayAmount: "roundDisplayAmount", league: "league", ownContestant: "ownContestant", isDoubleElimination: "isDoubleElimination", selectedParticipant: "selectedParticipant", participants: "participants" }, features: [i0.ɵɵNgOnChangesFeature], decls: 3, vars: 4, consts: [[1, "cup-bracket", "cup-rounds", "cup-rounds--upper-bracket"], [4, "ngFor", "ngForOf", "ngForTrackBy"], ["class", "cup-rounds__round cup-rounds__round--placeholder", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["class", "flex", 3, "round", "league", "ownContestant", "participants", "selectedParticipant", "isFirst", "isLast", "isDoubleElimination", "isFinal", "showSeeds", 4, "ngIf"], [1, "flex", 3, "round", "league", "ownContestant", "participants", "selectedParticipant", "isFirst", "isLast", "isDoubleElimination", "isFinal", "showSeeds"], [1, "cup-rounds__round", "cup-rounds__round--placeholder"]], template: function CupUpperBracketComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "article", 0);
        i0.ɵɵtemplate(1, CupUpperBracketComponent_ng_container_1_Template, 2, 1, "ng-container", 1);
        i0.ɵɵtemplate(2, CupUpperBracketComponent_div_2_Template, 1, 0, "div", 2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.rounds)("ngForTrackBy", ctx.trackRound);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.placeHolderRounds)("ngForTrackBy", ctx.trackRound);
    } }, directives: [i2.NgForOf, i2.NgIf, CupRoundComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CupUpperBracketComponent, [{
        type: Component,
        args: [{
                selector: "cup-upper-bracket",
                templateUrl: "./cup-upper-bracket.component.html",
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, { rounds: [{
            type: Input
        }], roundOffset: [{
            type: Input
        }], roundDisplayAmount: [{
            type: Input
        }], league: [{
            type: Input
        }], ownContestant: [{
            type: Input
        }], isDoubleElimination: [{
            type: Input
        }], selectedParticipant: [{
            type: Input
        }], participants: [{
            type: Input
        }] }); })();

const _c0$1 = function (a0, a1, a2) { return { "cup-bracket-navigation__button--disabled": a0, "cup-bracket-navigation__button--left": a1, "cup-bracket-navigation__button--right": a2 }; };
class CupBracketNavigationButtonComponent {
    constructor() {
        this.clicked = new EventEmitter();
    }
    get marginLeft() {
        return this.isRight ? "auto" : "initial";
    }
}
CupBracketNavigationButtonComponent.ɵfac = function CupBracketNavigationButtonComponent_Factory(t) { return new (t || CupBracketNavigationButtonComponent)(); };
CupBracketNavigationButtonComponent.ɵcmp = i0.ɵɵdefineComponent({ type: CupBracketNavigationButtonComponent, selectors: [["cup-bracket-navigation-button"]], hostVars: 2, hostBindings: function CupBracketNavigationButtonComponent_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵstyleProp("margin-left", ctx.marginLeft);
    } }, inputs: { isDisabled: ["disabled", "isDisabled"], isLeft: "isLeft", isRight: "isRight" }, outputs: { clicked: "clicked" }, decls: 1, vars: 6, consts: [[1, "cup-bracket-navigation__button", 3, "ngClass", "disabled", "click"]], template: function CupBracketNavigationButtonComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "button", 0);
        i0.ɵɵlistener("click", function CupBracketNavigationButtonComponent_Template_button_click_0_listener() { return ctx.clicked.emit(); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(2, _c0$1, ctx.isDisabled, ctx.isLeft, ctx.isRight))("disabled", ctx.isDisabled);
    } }, directives: [i2.NgClass], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CupBracketNavigationButtonComponent, [{
        type: Component,
        args: [{
                selector: "cup-bracket-navigation-button",
                templateUrl: "./cup-bracket-navigation-button.component.html",
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, { isDisabled: [{
            type: Input,
            args: ["disabled"]
        }], isLeft: [{
            type: Input
        }], isRight: [{
            type: Input
        }], clicked: [{
            type: Output
        }], marginLeft: [{
            type: HostBinding,
            args: ["style.margin-left"]
        }] }); })();

function CupBracketNavigationComponent_ng_container_4_cup_bracket_navigation_round_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "cup-bracket-navigation:third-place-round"), " ");
} }
const _c0 = function (a0, a1) { return { of: a0, first: a1 }; };
function CupBracketNavigationComponent_ng_container_4_cup_bracket_navigation_round_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const round_r2 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "cup-bracket-navigation:lower-round-of", i0.ɵɵpureFunction2(4, _c0, round_r2.length * 2, ctx_r5.isEvenRound(round_r2) ? 1 : 0)), " ");
} }
function CupBracketNavigationComponent_ng_container_4_cup_bracket_navigation_round_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "cup-bracket-navigation:lower-bracket-final"), " ");
} }
function CupBracketNavigationComponent_ng_container_4_cup_bracket_navigation_round_1_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "cup-bracket-navigation:second-grand-final"), " ");
} }
function CupBracketNavigationComponent_ng_container_4_cup_bracket_navigation_round_1_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "cup-bracket-navigation:grand-final"), " ");
} }
function CupBracketNavigationComponent_ng_container_4_cup_bracket_navigation_round_1_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "cup-bracket-navigation:winner-bracket-final"), " ");
} }
function CupBracketNavigationComponent_ng_container_4_cup_bracket_navigation_round_1_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "cup-bracket-navigation:semi-final"), " ");
} }
function CupBracketNavigationComponent_ng_container_4_cup_bracket_navigation_round_1_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "cup-bracket-navigation:quarter-final"), " ");
} }
const _c1 = function (a0) { return { of: a0 }; };
function CupBracketNavigationComponent_ng_container_4_cup_bracket_navigation_round_1_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const round_r2 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "cup-bracket-navigation:round-of", i0.ɵɵpureFunction1(4, _c1, round_r2.length * 2)), " ");
} }
function CupBracketNavigationComponent_ng_container_4_cup_bracket_navigation_round_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "cup-bracket-navigation-round", 8);
    i0.ɵɵtemplate(1, CupBracketNavigationComponent_ng_container_4_cup_bracket_navigation_round_1_ng_container_1_Template, 3, 3, "ng-container", 9);
    i0.ɵɵtemplate(2, CupBracketNavigationComponent_ng_container_4_cup_bracket_navigation_round_1_ng_container_2_Template, 3, 7, "ng-container", 9);
    i0.ɵɵtemplate(3, CupBracketNavigationComponent_ng_container_4_cup_bracket_navigation_round_1_ng_container_3_Template, 3, 3, "ng-container", 9);
    i0.ɵɵtemplate(4, CupBracketNavigationComponent_ng_container_4_cup_bracket_navigation_round_1_ng_container_4_Template, 3, 3, "ng-container", 9);
    i0.ɵɵtemplate(5, CupBracketNavigationComponent_ng_container_4_cup_bracket_navigation_round_1_ng_container_5_Template, 3, 3, "ng-container", 9);
    i0.ɵɵtemplate(6, CupBracketNavigationComponent_ng_container_4_cup_bracket_navigation_round_1_ng_container_6_Template, 3, 3, "ng-container", 9);
    i0.ɵɵtemplate(7, CupBracketNavigationComponent_ng_container_4_cup_bracket_navigation_round_1_ng_container_7_Template, 3, 3, "ng-container", 9);
    i0.ɵɵtemplate(8, CupBracketNavigationComponent_ng_container_4_cup_bracket_navigation_round_1_ng_container_8_Template, 3, 3, "ng-container", 9);
    i0.ɵɵtemplate(9, CupBracketNavigationComponent_ng_container_4_cup_bracket_navigation_round_1_ng_container_9_Template, 3, 6, "ng-container", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const round_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngSwitch", ctx_r3.getRoundType(round_r2));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "third-place-match");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "lower-bracket");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "lower-bracket-final");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "second-grand-final");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "grand-final");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "winner-bracket-final");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "semi-final");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "quarter-final");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "default");
} }
function CupBracketNavigationComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CupBracketNavigationComponent_ng_container_4_cup_bracket_navigation_round_1_Template, 10, 10, "cup-bracket-navigation-round", 7);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const round_r2 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.filterException(round_r2));
} }
function CupBracketNavigationComponent_cup_bracket_navigation_round_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "cup-bracket-navigation-round", 10);
} }
class CupBracketNavigationComponent {
    constructor() {
        this.setOffset = new EventEmitter();
    }
    /**
     * React on keypress, check if arrow keys are pressed
     *
     * @param event
     */
    scrollBracket(event) {
        if (event.keyCode === 37) {
            // left arrow key
            this.navigateLeft();
        }
        if (event.keyCode === 39) {
            // right arrow key
            this.navigateRight();
        }
    }
    ngOnChanges(changes) {
        this.selectedRounds = slice(this.rounds, this.offset, this.offset + this.roundDisplayAmount);
        this.placeHolderRounds = range(0, this.roundDisplayAmount - this.selectedRounds.length);
    }
    navigateLeft() {
        if (this.offset > 0) {
            this.setOffset.emit(this.offset - 1);
        }
    }
    navigateRight() {
        if (this.offset < this.rounds.length - this.roundDisplayAmount) {
            this.setOffset.emit(this.offset + 1);
        }
    }
    getRoundType(round) {
        switch (true) {
            case this.roundIsThirdPlaceMatch(round):
                return "third-place-match";
            case this.roundIsLowerBracketFinal(round):
                return "lower-bracket-final";
            case this.isLowerBracket:
                return "lower-bracket";
            case this.roundIsSemiFinal(round):
                return "semi-final";
            case this.roundIsQuarterFinal(round):
                return "quarter-final";
            case this.roundIsGrandFinal(round):
                return "grand-final";
            case this.roundIsSecondGrandFinal(round):
                return "second-grand-final";
            case this.roundIsWinnerBracketFinal(round):
                return "winner-bracket-final";
            default:
                return "default";
        }
    }
    filterException(round) {
        /**
         * Check for cancelled final #2 in a DoubleDouble Final league.
         */
        if (this.league.cupMode === "double_double_final" && last(this.rounds) === round && round[0].state === "cancelled") {
            return false;
        }
        return true;
    }
    isEvenRound(round) {
        return this.rounds.indexOf(round) % 2 === 0;
    }
    roundIsThirdPlaceMatch(round) {
        return !this.isLowerBracket && sample(this.rounds[0]).bracket === 1;
    }
    roundIsGrandFinal(round) {
        if (this.league.cupMode === "double_double_final") {
            return !this.isLowerBracket && this.rounds[this.rounds.length - 2] === round;
        }
        return !this.isLowerBracket && last(this.rounds) === round;
    }
    roundIsSecondGrandFinal(round) {
        if (this.league.cupMode !== "double_double_final") {
            return false;
        }
        return !this.isLowerBracket && last(this.rounds) === round;
    }
    roundIsLowerBracketFinal(round) {
        return last(this.lowerBracket(this.rounds)) === round;
    }
    roundIsWinnerBracketFinal(round) {
        return !this.isLowerBracket && round.length === 1;
    }
    roundIsSemiFinal(round) {
        return !this.isLowerBracket && round.length === 2;
    }
    roundIsQuarterFinal(round) {
        return !this.isLowerBracket && round.length === 4;
    }
    isLowerBracketRound(round) {
        const firstRound = first(round);
        return firstRound ? firstRound.bracket === 1 : false;
    }
    lowerBracket(rounds) {
        return rounds.filter(this.isLowerBracketRound);
    }
    trackIndex(index, item) {
        return index;
    }
}
CupBracketNavigationComponent.ɵfac = function CupBracketNavigationComponent_Factory(t) { return new (t || CupBracketNavigationComponent)(); };
CupBracketNavigationComponent.ɵcmp = i0.ɵɵdefineComponent({ type: CupBracketNavigationComponent, selectors: [["cup-bracket-navigation"]], hostBindings: function CupBracketNavigationComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("keydown", function CupBracketNavigationComponent_keydown_HostBindingHandler($event) { return ctx.scrollBracket($event); }, false, i0.ɵɵresolveDocument);
    } }, inputs: { league: "league", isLowerBracket: "isLowerBracket", rounds: "rounds", roundDisplayAmount: "roundDisplayAmount", offset: "offset" }, outputs: { setOffset: "setOffset" }, features: [i0.ɵɵNgOnChangesFeature], decls: 8, vars: 8, consts: [[1, "cup-bracket-navigation"], [1, "cup-bracket-navigation__spacer"], [3, "disabled", "isLeft", "clicked"], [1, "cup-bracket-navigation__rounds"], [4, "ngFor", "ngForOf", "ngForTrackBy"], ["class", "cup-bracket-navigation__rounds__round--placeholder", 4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "disabled", "isRight", "clicked"], [3, "ngSwitch", 4, "ngIf"], [3, "ngSwitch"], [4, "ngSwitchCase"], [1, "cup-bracket-navigation__rounds__round--placeholder"]], template: function CupBracketNavigationComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "article", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "cup-bracket-navigation-button", 2);
        i0.ɵɵlistener("clicked", function CupBracketNavigationComponent_Template_cup_bracket_navigation_button_clicked_2_listener() { return ctx.navigateLeft(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵtemplate(4, CupBracketNavigationComponent_ng_container_4_Template, 2, 1, "ng-container", 4);
        i0.ɵɵtemplate(5, CupBracketNavigationComponent_cup_bracket_navigation_round_5_Template, 1, 0, "cup-bracket-navigation-round", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 1);
        i0.ɵɵelementStart(7, "cup-bracket-navigation-button", 6);
        i0.ɵɵlistener("clicked", function CupBracketNavigationComponent_Template_cup_bracket_navigation_button_clicked_7_listener() { return ctx.navigateRight(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("disabled", ctx.offset <= 0)("isLeft", true);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.selectedRounds)("ngForTrackBy", ctx.trackIndex);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.placeHolderRounds)("ngForTrackBy", ctx.trackIndex);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("disabled", ctx.offset >= (ctx.rounds == null ? null : ctx.rounds.length) - ctx.roundDisplayAmount)("isRight", true);
    } }, directives: [CupBracketNavigationButtonComponent, i2.NgForOf, i2.NgIf, CupBracketNavigationRoundComponent, i2.NgSwitch, i2.NgSwitchCase], pipes: [i3.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CupBracketNavigationComponent, [{
        type: Component,
        args: [{
                selector: "cup-bracket-navigation",
                templateUrl: "./cup-bracket-navigation.component.html",
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, { league: [{
            type: Input
        }], isLowerBracket: [{
            type: Input
        }], rounds: [{
            type: Input
        }], roundDisplayAmount: [{
            type: Input
        }], offset: [{
            type: Input
        }], setOffset: [{
            type: Output
        }], scrollBracket: [{
            type: HostListener,
            args: ["document:keydown", ["$event"]]
        }] }); })();

class DOMHelper {
    /**
     * Find the offset relative to the document of an element
     * Cross-browser compatible
     * @param element
     */
    findWindowOffsetTop(element) {
        const box = element.getBoundingClientRect();
        const body = document.body;
        const docEl = document.documentElement;
        // Get current scroll
        const scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
        // Get top position of the body
        const clientTop = docEl.clientTop || body.clientTop || 0;
        // Calculate the offset of the element
        const top = box.top + scrollTop - clientTop;
        return Math.round(top);
    }
}
DOMHelper.ɵfac = function DOMHelper_Factory(t) { return new (t || DOMHelper)(); };
DOMHelper.ɵprov = i0.ɵɵdefineInjectable({ token: DOMHelper, factory: DOMHelper.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DOMHelper, [{
        type: Injectable
    }], null, null); })();

class BracketSegmenter {
    /**
     * Split a bracket into segments that are also brackets.
     * @param bracket       The bracket to segment.
     * @param roundOffset   Current offset within bracket.
     * @param
     */
    segment(bracket, roundOffset, segmentSize, isLowerBracket) {
        const firstRoundChunks = chunk(bracket[0], segmentSize);
        const bracketSegments = firstRoundChunks.map((ch, chunkIndex) => {
            return bracket.map((round, roundIndex) => {
                const difference = roundIndex - roundOffset;
                let power;
                if (isLowerBracket) {
                    if (roundOffset % 2 === 0) {
                        if (difference % 2 !== 0) {
                            power = (difference - 1) / 2;
                        }
                        else {
                            power = difference / 2;
                        }
                    }
                    else {
                        if (difference % 2 !== 0) {
                            power = (difference + 1) / 2;
                        }
                        else {
                            power = difference / 2;
                        }
                    }
                }
                else {
                    power = difference;
                }
                const chunkSize = segmentSize / Math.pow(2, power);
                const start = chunkSize * chunkIndex;
                const end = start + chunkSize;
                return round.slice(start, end);
            });
        });
        return bracketSegments;
    }
}
BracketSegmenter.ɵfac = function BracketSegmenter_Factory(t) { return new (t || BracketSegmenter)(); };
BracketSegmenter.ɵprov = i0.ɵɵdefineInjectable({ token: BracketSegmenter, factory: BracketSegmenter.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BracketSegmenter, [{
        type: Injectable
    }], null, null); })();

const BRACKET_CONFIG = new InjectionToken("bracket.config");
const bracketBaseConfig = {
    upperBracketMatchHeight: 102,
    lowerBracketMatchHeight: 112,
    lowerBracketMargin: 70,
    segmentSize: 8,
    segmentLimit: 3,
};

function SegmentedBracketRendererComponent_ng_container_1_cup_upper_bracket_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "cup-upper-bracket", 3);
} if (rf & 2) {
    const segment_r3 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("height", ctx_r2.segmentHeight, "px")("top", segment_r3.topPos, "px");
    i0.ɵɵproperty("rounds", segment_r3.rounds)("roundOffset", ctx_r2.roundOffset)("roundDisplayAmount", ctx_r2.roundDisplayAmount)("league", ctx_r2.league)("ownContestant", ctx_r2.ownContestant)("participants", ctx_r2.participants)("selectedParticipant", ctx_r2.selectedParticipant)("isDoubleElimination", ctx_r2.isDoubleElimination);
} }
function SegmentedBracketRendererComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SegmentedBracketRendererComponent_ng_container_1_cup_upper_bracket_1_Template, 1, 12, "cup-upper-bracket", 2);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.limitedSegments)("ngForTrackBy", ctx_r0.trackIndex);
} }
function SegmentedBracketRendererComponent_ng_container_2_cup_lower_bracket_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "cup-lower-bracket", 5);
} if (rf & 2) {
    const segment_r5 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("height", ctx_r4.segmentHeight, "px")("top", segment_r5.topPos, "px");
    i0.ɵɵproperty("rounds", segment_r5.rounds)("roundOffset", ctx_r4.roundOffset)("roundDisplayAmount", ctx_r4.roundDisplayAmount)("league", ctx_r4.league)("ownContestant", ctx_r4.ownContestant)("participants", ctx_r4.participants)("selectedParticipant", ctx_r4.selectedParticipant);
} }
function SegmentedBracketRendererComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SegmentedBracketRendererComponent_ng_container_2_cup_lower_bracket_1_Template, 1, 11, "cup-lower-bracket", 4);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r1.limitedSegments)("ngForTrackBy", ctx_r1.trackIndex);
} }
class SegmentedBracketRendererComponent {
    constructor(zone, domHelper, bracketConfig, bracketSegmenter) {
        this.zone = zone;
        this.domHelper = domHelper;
        this.bracketConfig = bracketConfig;
        this.bracketSegmenter = bracketSegmenter;
        this.setSegmentOffset = new EventEmitter();
        this.getTopLeftMatch = new EventEmitter();
        this.getTopSecondFromLeftMatch = new EventEmitter();
        this.upperBracketMatchHeight = this.bracketConfig.upperBracketMatchHeight;
        this.lowerBracketMatchHeight = this.bracketConfig.lowerBracketMatchHeight;
        this.lowerBracketMargin = this.bracketConfig.lowerBracketMargin;
        this.matchHeight = this.bracketConfig.upperBracketMatchHeight;
        this.segmentSize = this.bracketConfig.segmentSize;
        this.segmentHeight = this.segmentSize * this.matchHeight;
        this.segmentLimit = this.bracketConfig.segmentLimit;
    }
    ngOnChanges(changes) {
        if (changes["isLowerBracket"]) {
            this.matchHeight = this.isLowerBracket ? this.lowerBracketMatchHeight : this.upperBracketMatchHeight;
        }
        if (changes["isLowerBracket"] || changes["segmentSize"]) {
            this.segmentHeight = this.isLowerBracket
                ? this.segmentSize * this.matchHeight + this.lowerBracketMargin
                : this.segmentSize * this.matchHeight;
        }
        if (!isUndefined(this.roundOffset)) {
            if (changes["rounds"] ||
                changes["roundOffset"] ||
                changes["segmentSize"] ||
                changes["isLowerBracket"] ||
                changes["segmentHeight"]) {
                const bracketSegments = this.bracketSegmenter.segment(this.rounds, this.roundOffset, this.segmentSize, this.isLowerBracket);
                this.segmentsWithData = this.mapDataToSegments(bracketSegments, this.segmentHeight, this.isLowerBracket);
            }
            this.limitedSegments = this.segmentsWithData.slice(this.segmentOffset, this.segmentOffset + this.segmentLimit).map(segment => {
                return assign({}, segment, {
                    rounds: segment.rounds.slice(this.roundOffset, this.roundOffset + this.roundDisplayAmount),
                });
            });
            this.findLeftMostMatches();
        }
        this.containerHeight = this.getContainerHeight();
    }
    /**
     * @TODO Move outside of ngZone
     */
    ngOnInit() {
        this.zone.runOutsideAngular(() => {
            window.addEventListener("scroll", debounce(() => {
                this.zone.run(() => {
                    this.setSegmentPositions();
                    this.findLeftMostMatches();
                });
            }, 50));
            window.addEventListener("scroll", throttle(() => {
                this.zone.run(() => {
                    this.setSegmentPositions();
                    this.findLeftMostMatches();
                });
            }, 200));
        });
    }
    findLeftMostMatches() {
        if (this.limitedSegments.length < 1) {
            return;
        }
        let evenOffset = false;
        if (this.isLowerBracket) {
            if (this.roundOffset % 2) {
                evenOffset = true;
            }
            else if (this.roundOffset % 2 === 0) {
                evenOffset = false;
            }
        }
        const bracketContainer = document.getElementById("segmented-bracket-renderer");
        if (!bracketContainer) {
            return;
        }
        const topGap = this.domHelper.findWindowOffsetTop(bracketContainer);
        // Figure out if we are in the top or middle segment
        const currTopSegment = this.limitedSegments.length > 1 && window.scrollY - topGap + this.matchHeight * 2 >= this.limitedSegments[1].topPos ? 1 : 0;
        // Find offset from top position of current segment
        const segmentOffset = window.scrollY - topGap - this.limitedSegments[currTopSegment].topPos + this.matchHeight;
        // Calculate the match we're currently looking at
        const currTopLeftMatchMath = this.isLowerBracket
            ? evenOffset
                ? Math.ceil((segmentOffset - 9) / this.matchHeight)
                : Math.ceil((segmentOffset - 65) / this.matchHeight)
            : Math.ceil(segmentOffset / this.matchHeight);
        const currTopLeftMatch = currTopLeftMatchMath > 0
            ? currTopLeftMatchMath === this.limitedSegments[currTopSegment].rounds[0].length
                ? 0
                : currTopLeftMatchMath
            : 0;
        const newTopLeftMatch = this.limitedSegments[currTopSegment].rounds[0][currTopLeftMatch];
        if (newTopLeftMatch !== this.topLeftMatch) {
            this.getTopLeftMatch.emit(newTopLeftMatch);
            this.topLeftMatch = newTopLeftMatch;
        }
        // Calculate the second from left match we're looking at. Factors in the offset from being the second round shown.
        const currTopSecondFromLeftMatchMath = this.isLowerBracket
            ? evenOffset
                ? Math.ceil((segmentOffset - this.matchHeight / 2 - 9) / this.matchHeight / 2)
                : Math.ceil((segmentOffset - 9) / this.matchHeight)
            : Math.ceil((segmentOffset - this.matchHeight / 2) / this.matchHeight / 2);
        const currTopSecondFromLeftMatch = currTopSecondFromLeftMatchMath > 0
            ? currTopSecondFromLeftMatchMath === this.limitedSegments[currTopSegment].rounds[1].length
                ? 0
                : currTopSecondFromLeftMatchMath
            : 0;
        const newTopSecondFromLeftMatch = this.limitedSegments[currTopSegment].length > 1
            ? this.limitedSegments[currTopSegment].rounds[1][currTopSecondFromLeftMatch]
            : null;
        if (newTopSecondFromLeftMatch !== this.topSecondFromLeftMatch) {
            this.getTopSecondFromLeftMatch.emit(newTopSecondFromLeftMatch);
            this.topSecondFromLeftMatch = newTopSecondFromLeftMatch;
        }
    }
    /**
     * Map metadata to segments.
     * @param segments         All segments.
     * @param segmentHeight    The calculated height of a segment.
     * @param isLowerBracket   True if calculating lower bracket segments.
     * @return Segments with metadata mapped to them.
     */
    mapDataToSegments(segments, segmentHeight, isLowerBracket) {
        return segments.map((segment, index) => {
            return {
                rounds: segment,
                topPos: segmentHeight * index - (isLowerBracket ? index * 72 : 0),
                index: index,
            };
        });
    }
    /**
     * Update which segments are to be displayed.
     */
    setSegmentPositions() {
        // TODO find by component instance, not by id (possibility to render multiple brackets).
        const bracketContainer = document.getElementById("segmented-bracket-renderer");
        if (!bracketContainer) {
            return;
        }
        const topGap = this.domHelper.findWindowOffsetTop(bracketContainer);
        // Distance (in px) from window top to segment in middle of viewport.
        const offset = window.scrollY - topGap + window.innerHeight / 2 > 0 ? window.scrollY - topGap + window.innerHeight / 2 : 0;
        // Amount of segments to be skipped.
        const segmentSkip = offset / (this.segmentSize * this.matchHeight);
        const newOffset = Math.floor(segmentSkip - 1 >= 0 ? segmentSkip - 1 : 0);
        if (newOffset !== this.segmentOffset) {
            this.setSegmentOffset.emit(newOffset);
        }
    }
    /**
     * Calculate height of the element containing all segments.
     */
    getContainerHeight() {
        const firstRenderedRound = this.rounds[this.roundOffset];
        const firstRoundLength = firstRenderedRound.length;
        const bonusHeight = this.isLowerBracket && this.roundOffset % 2 === 0 ? this.lowerBracketMargin : 0;
        return firstRoundLength * this.matchHeight + bonusHeight;
    }
    trackIndex(index, item) {
        return item.index;
    }
}
SegmentedBracketRendererComponent.ɵfac = function SegmentedBracketRendererComponent_Factory(t) { return new (t || SegmentedBracketRendererComponent)(i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(DOMHelper), i0.ɵɵdirectiveInject(BRACKET_CONFIG), i0.ɵɵdirectiveInject(BracketSegmenter)); };
SegmentedBracketRendererComponent.ɵcmp = i0.ɵɵdefineComponent({ type: SegmentedBracketRendererComponent, selectors: [["segmented-bracket-renderer"]], inputs: { league: "league", ownContestant: "ownContestant", selectedParticipant: "selectedParticipant", participants: "participants", rounds: "rounds", roundOffset: "roundOffset", roundDisplayAmount: "roundDisplayAmount", isDoubleElimination: "isDoubleElimination", hasThirdPlaceMatch: "hasThirdPlaceMatch", isLowerBracket: "isLowerBracket", segmentOffset: "segmentOffset", segmentLimit: "segmentLimit" }, outputs: { setSegmentOffset: "setSegmentOffset", getTopLeftMatch: "getTopLeftMatch", getTopSecondFromLeftMatch: "getTopSecondFromLeftMatch" }, features: [i0.ɵɵNgOnChangesFeature], decls: 3, vars: 4, consts: [["id", "segmented-bracket-renderer", 2, "position", "relative", "overflow", "hidden"], [4, "ngIf"], ["style", "position: absolute; width: 100%;", 3, "rounds", "roundOffset", "roundDisplayAmount", "league", "ownContestant", "participants", "selectedParticipant", "isDoubleElimination", "height", "top", 4, "ngFor", "ngForOf", "ngForTrackBy"], [2, "position", "absolute", "width", "100%", 3, "rounds", "roundOffset", "roundDisplayAmount", "league", "ownContestant", "participants", "selectedParticipant", "isDoubleElimination"], ["style", "position: absolute; width: 100%;", 3, "rounds", "roundOffset", "roundDisplayAmount", "league", "ownContestant", "participants", "selectedParticipant", "height", "top", 4, "ngFor", "ngForOf", "ngForTrackBy"], [2, "position", "absolute", "width", "100%", 3, "rounds", "roundOffset", "roundDisplayAmount", "league", "ownContestant", "participants", "selectedParticipant"]], template: function SegmentedBracketRendererComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, SegmentedBracketRendererComponent_ng_container_1_Template, 2, 2, "ng-container", 1);
        i0.ɵɵtemplate(2, SegmentedBracketRendererComponent_ng_container_2_Template, 2, 2, "ng-container", 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵstyleProp("height", ctx.containerHeight, "px");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isLowerBracket);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isLowerBracket);
    } }, directives: [i2.NgIf, i2.NgForOf, CupUpperBracketComponent, CupLowerBracketComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SegmentedBracketRendererComponent, [{
        type: Component,
        args: [{
                selector: "segmented-bracket-renderer",
                templateUrl: "./segmented-bracket-renderer.component.html",
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i0.NgZone }, { type: DOMHelper }, { type: undefined, decorators: [{
                type: Inject,
                args: [BRACKET_CONFIG]
            }] }, { type: BracketSegmenter }]; }, { league: [{
            type: Input
        }], ownContestant: [{
            type: Input
        }], selectedParticipant: [{
            type: Input
        }], participants: [{
            type: Input
        }], rounds: [{
            type: Input
        }], roundOffset: [{
            type: Input
        }], roundDisplayAmount: [{
            type: Input
        }], isDoubleElimination: [{
            type: Input
        }], hasThirdPlaceMatch: [{
            type: Input
        }], isLowerBracket: [{
            type: Input
        }], segmentOffset: [{
            type: Input
        }], segmentLimit: [{
            type: Input
        }], setSegmentOffset: [{
            type: Output
        }], getTopLeftMatch: [{
            type: Output
        }], getTopSecondFromLeftMatch: [{
            type: Output
        }] }); })();

class BracketComponentsModule {
}
BracketComponentsModule.ɵfac = function BracketComponentsModule_Factory(t) { return new (t || BracketComponentsModule)(); };
BracketComponentsModule.ɵmod = i0.ɵɵdefineNgModule({ type: BracketComponentsModule });
BracketComponentsModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[CommonModule, TranslationModule, CommonsComponentModule, CommonsLocationModule, PremiumModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(BracketComponentsModule, { declarations: [CupBracketSelectorComponent,
        CupBracketSelectorButtonComponent,
        CupBracketNavigationRoundComponent,
        CupMyPositionButtonComponent,
        CupMatchComponent,
        CupMatchParticipantComponent,
        CupContestantLinkComponent,
        CupMatchLinkComponent,
        CupRoundComponent,
        CupLowerBracketRoundComponent,
        CupLowerBracketComponent,
        CupUpperBracketComponent,
        CupBracketNavigationComponent,
        CupBracketNavigationButtonComponent,
        SegmentedBracketRendererComponent], imports: [CommonModule, TranslationModule, CommonsComponentModule, CommonsLocationModule, PremiumModule], exports: [CupBracketSelectorComponent,
        CupBracketSelectorButtonComponent,
        CupBracketNavigationRoundComponent,
        CupMyPositionButtonComponent,
        CupMatchComponent,
        CupMatchParticipantComponent,
        CupContestantLinkComponent,
        CupMatchLinkComponent,
        CupRoundComponent,
        CupLowerBracketRoundComponent,
        CupLowerBracketComponent,
        CupUpperBracketComponent,
        CupBracketNavigationComponent,
        CupBracketNavigationButtonComponent,
        SegmentedBracketRendererComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BracketComponentsModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, TranslationModule, CommonsComponentModule, CommonsLocationModule, PremiumModule],
                declarations: [
                    CupBracketSelectorComponent,
                    CupBracketSelectorButtonComponent,
                    CupBracketNavigationRoundComponent,
                    CupMyPositionButtonComponent,
                    CupMatchComponent,
                    CupMatchParticipantComponent,
                    CupContestantLinkComponent,
                    CupMatchLinkComponent,
                    CupRoundComponent,
                    CupLowerBracketRoundComponent,
                    CupLowerBracketComponent,
                    CupUpperBracketComponent,
                    CupBracketNavigationComponent,
                    CupBracketNavigationButtonComponent,
                    SegmentedBracketRendererComponent,
                ],
                exports: [
                    CupBracketSelectorComponent,
                    CupBracketSelectorButtonComponent,
                    CupBracketNavigationRoundComponent,
                    CupMyPositionButtonComponent,
                    CupMatchComponent,
                    CupMatchParticipantComponent,
                    CupContestantLinkComponent,
                    CupMatchLinkComponent,
                    CupRoundComponent,
                    CupLowerBracketRoundComponent,
                    CupLowerBracketComponent,
                    CupUpperBracketComponent,
                    CupBracketNavigationComponent,
                    CupBracketNavigationButtonComponent,
                    SegmentedBracketRendererComponent,
                ],
            }]
    }], null, null); })();

class BracketBuilder {
    /**
     * Build a bracket structure that is render friendly from an array of matches.
     *
     * @param matches All matches of a cup.
     *
     * @returns The matches as an array structure.
     */
    build(matches) {
        const ordered = orderBy(matches, "position");
        const grouped = groupBy(ordered, "bracket");
        return map$1(grouped, bracket => {
            const groupedRounds = groupBy(bracket, "round");
            return map$1(groupedRounds, round => round);
        });
    }
}
BracketBuilder.ɵfac = function BracketBuilder_Factory(t) { return new (t || BracketBuilder)(); };
BracketBuilder.ɵprov = i0.ɵɵdefineInjectable({ token: BracketBuilder, factory: BracketBuilder.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BracketBuilder, [{
        type: Injectable
    }], null, null); })();

class MatchScrollPositionCalculator {
    constructor(config) {
        this.upperBracketMatchHeight = config.upperBracketMatchHeight;
        this.lowerBracketMatchHeight = config.lowerBracketMatchHeight;
    }
    /**
     * Calculates the Matchposition relative to the top of the bracket container
     * @param matchIndex The index of the match inside the round array (could be seen as the y position)
     * @param roundIndex The index of the current round in the array of visible rounds
     * @param bracketIndex The index of the bracket (0 = upper Bracket, 1 = thirdplace / lower bracket)
     * @param roundOffset The offset of the rounds (also, the index of the left most round in
     * the array of visible rounds)
     * @returns The position of the match with the given index in pixels
     */
    calculateRelativeMatchPosition(matchIndex, roundIndex, bracketIndex, roundOffset) {
        //the visible position of the round the given match is in
        const actualOffset = roundIndex - roundOffset;
        if (bracketIndex === 0) {
            //upper bracket
            //expected:
            //actualOffset:             0 1 2 3 4 5 6 7
            //roundSizeMultiplicator:   1 2 4 8 16 32 64
            const roundSizeMultiplicator = Math.pow(2, actualOffset);
            // is added to return the center position of the current round
            return this.upperBracketMatchHeight * matchIndex * roundSizeMultiplicator + this.upperBracketMatchHeight / 2;
        }
        else {
            let roundSizeMultiplicator;
            if (roundOffset % 2 === 0) {
                //lower bracket, even roundOffset
                //expected:
                //actualOffset:             0 1 2 3 4 5 6 7
                //roundSizeMultiplicator:   1 1 2 2 4 4 8 8
                roundSizeMultiplicator = Math.pow(2, Math.floor(actualOffset / 2));
            }
            else {
                //lower bracket, uneven roundOffset
                //expected:
                //actualOffset:             0 1 2 3 4 5 6 7
                //roundSizeMultiplicator:   1 2 2 4 4 8 8 16
                roundSizeMultiplicator = Math.pow(2, Math.ceil(actualOffset / 2));
            }
            //Every second round, there is a space on top of it in the lower bracket
            let topSpaceOffset = 0;
            if (roundOffset % 2 === actualOffset % 2) {
                topSpaceOffset = this.lowerBracketMatchHeight / 2;
            }
            //is added to return the center position of the current round, which
            return roundSizeMultiplicator * this.lowerBracketMatchHeight * matchIndex + topSpaceOffset + this.lowerBracketMatchHeight / 2;
            //should in theory not work in the lower bracket, as the matches are not in the middle of the
            //matchContainer (the thing that gets ng-repeated), but on top. Somehow still works. Better do not touch.
        }
    }
}
MatchScrollPositionCalculator.ɵfac = function MatchScrollPositionCalculator_Factory(t) { return new (t || MatchScrollPositionCalculator)(i0.ɵɵinject(BRACKET_CONFIG)); };
MatchScrollPositionCalculator.ɵprov = i0.ɵɵdefineInjectable({ token: MatchScrollPositionCalculator, factory: MatchScrollPositionCalculator.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MatchScrollPositionCalculator, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [BRACKET_CONFIG]
            }] }]; }, null); })();

class ContestantMatchesService {
    /**
     * gets matches where the given contestant is participating in a flat array
     * and adds the roundIndex it had in the given bracket to them
     * @param contestantId
     * @param brackets
     */
    getMatchesForContestantAsCupBracket(contestantId, brackets) {
        return map$1(brackets, bracket => {
            return map$1(bracket, round => {
                return reduce(round, (filteredRound, match) => {
                    if (find(match.participants, participant => participant.id === contestantId)) {
                        filteredRound.push(match);
                    }
                    else {
                        filteredRound.push(null);
                    }
                    return filteredRound;
                }, []);
            });
        });
    }
    /**
     * return the last match of a contestant
     * @param contestantId
     * @param matches
     * @returns IApiMatchResult
     */
    getLastMatchForContestant(contestantId, matches) {
        return findLast(sortBy(matches, ["round"]), match => {
            return find(match.participants, participant => participant.id === contestantId);
        });
    }
    /**
     * returns the round index for the last match
     * @param contestantId
     * @param bracket
     * @param bracketIndex
     * @returns -1 if no match has been found
     */
    getLastMatchRoundIndexForContestant(contestantId, bracket, bracketIndex) {
        const filteredBracket = this.getMatchesForContestantAsCupBracket(contestantId, bracket);
        return findLastIndex(filteredBracket[bracketIndex], round => find(round, match => match));
    }
}
ContestantMatchesService.ɵfac = function ContestantMatchesService_Factory(t) { return new (t || ContestantMatchesService)(); };
ContestantMatchesService.ɵprov = i0.ɵɵdefineInjectable({ token: ContestantMatchesService, factory: ContestantMatchesService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ContestantMatchesService, [{
        type: Injectable
    }], null, null); })();

class RoundMapper {
    /**
     * @param roundIndex
     */
    getLowerBracketRoundIndexForUpperBracketRoundIndex(roundIndex) {
        return roundIndex * 2;
    }
    /**
     * @param roundIndex
     */
    getUpperBracketRoundIndexForLowerBracketRoundIndex(roundIndex) {
        return Math.floor((roundIndex + 1) / 2);
    }
    /**
     * @param amountOfRoundInUpperBracket
     */
    getUpperBracketRoundIndexForThirdPlaceMatch(amountOfRoundInUpperBracket) {
        return amountOfRoundInUpperBracket - 2;
    }
    getThirdPlaceMatchRoundIndex() {
        return 0;
    }
}
RoundMapper.ɵfac = function RoundMapper_Factory(t) { return new (t || RoundMapper)(); };
RoundMapper.ɵprov = i0.ɵɵdefineInjectable({ token: RoundMapper, factory: RoundMapper.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RoundMapper, [{
        type: Injectable
    }], null, null); })();

function PlayCupBracketComponent_div_1_cup_my_position_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cup-my-position-button", 11);
    i0.ɵɵlistener("click", function PlayCupBracketComponent_div_1_cup_my_position_button_5_Template_cup_my_position_button_click_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(2); return ctx_r5.goToMyPosition(); });
    i0.ɵɵelementEnd();
} }
function PlayCupBracketComponent_div_1_cup_bracket_navigation_7_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cup-bracket-navigation", 12);
    i0.ɵɵlistener("setOffset", function PlayCupBracketComponent_div_1_cup_bracket_navigation_7_Template_cup_bracket_navigation_setOffset_0_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(2); return ctx_r8.setRoundOffset($event); });
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const bracket_r7 = ctx.ngIf;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("league", ctx_r3.league)("isLowerBracket", ctx_r3.isDoubleElimination && i0.ɵɵpipeBind1(1, 5, ctx_r3.selectedBracket$) ? true : false)("rounds", bracket_r7[i0.ɵɵpipeBind1(2, 7, ctx_r3.selectedBracket$)])("roundDisplayAmount", ctx_r3.roundDisplayAmount)("offset", i0.ɵɵpipeBind1(3, 9, ctx_r3.roundOffset$));
} }
function PlayCupBracketComponent_div_1_segmented_bracket_renderer_9_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "segmented-bracket-renderer", 13);
    i0.ɵɵlistener("setSegmentOffset", function PlayCupBracketComponent_div_1_segmented_bracket_renderer_9_Template_segmented_bracket_renderer_setSegmentOffset_0_listener($event) { i0.ɵɵrestoreView(_r12); const ctx_r11 = i0.ɵɵnextContext(2); return ctx_r11.setSegmentOffset($event); })("getTopLeftMatch", function PlayCupBracketComponent_div_1_segmented_bracket_renderer_9_Template_segmented_bracket_renderer_getTopLeftMatch_0_listener($event) { i0.ɵɵrestoreView(_r12); const ctx_r13 = i0.ɵɵnextContext(2); return ctx_r13.setTopLeftMatch($event); })("getTopSecondFromLeftMatch", function PlayCupBracketComponent_div_1_segmented_bracket_renderer_9_Template_segmented_bracket_renderer_getTopSecondFromLeftMatch_0_listener($event) { i0.ɵɵrestoreView(_r12); const ctx_r14 = i0.ɵɵnextContext(2); return ctx_r14.setTopSecondFromLeftMatch($event); });
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const bracket_r10 = ctx.ngIf;
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("rounds", bracket_r10[i0.ɵɵpipeBind1(1, 11, ctx_r4.selectedBracket$)])("roundOffset", i0.ɵɵpipeBind1(2, 13, ctx_r4.roundOffset$))("roundDisplayAmount", ctx_r4.roundDisplayAmount)("league", ctx_r4.league)("ownContestant", ctx_r4.ownContestant)("participants", ctx_r4.participants)("selectedParticipant", ctx_r4.selectedParticipant)("isDoubleElimination", ctx_r4.isDoubleElimination)("hasThirdPlaceMatch", ctx_r4.hasThirdPlaceMatch)("isLowerBracket", ctx_r4.isDoubleElimination && i0.ɵɵpipeBind1(3, 15, ctx_r4.selectedBracket$) === 1)("segmentOffset", i0.ɵɵpipeBind1(4, 17, ctx_r4.segmentOffset$));
} }
function PlayCupBracketComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelementStart(1, "div", 4);
    i0.ɵɵelementStart(2, "div", 5);
    i0.ɵɵelementStart(3, "cup-bracket-selector", 6);
    i0.ɵɵlistener("selected", function PlayCupBracketComponent_div_1_Template_cup_bracket_selector_selected_3_listener($event) { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(); return ctx_r15.selectBracket($event); });
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, PlayCupBracketComponent_div_1_cup_my_position_button_5_Template, 1, 0, "cup-my-position-button", 7);
    i0.ɵɵelement(6, "cup-page-participant-switcher", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, PlayCupBracketComponent_div_1_cup_bracket_navigation_7_Template, 4, 11, "cup-bracket-navigation", 9);
    i0.ɵɵpipe(8, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, PlayCupBracketComponent_div_1_segmented_bracket_renderer_9_Template, 5, 19, "segmented-bracket-renderer", 10);
    i0.ɵɵpipe(10, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("isDoubleElimination", ctx_r0.isDoubleElimination)("hasThirdPlaceMatch", ctx_r0.hasThirdPlaceMatch)("selectedBracket", i0.ɵɵpipeBind1(4, 7, ctx_r0.selectedBracket$));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.ownContestant);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("leagueId", ctx_r0.league.id);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(8, 9, ctx_r0.bracket$));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(10, 11, ctx_r0.bracket$));
} }
function PlayCupBracketComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "cup-bracket:no-bracket"), " ");
} }
class PlayCupBracketComponent {
    constructor(domHelper, bracketBuilder, matchScrollPositionCalculator, contestantMatchesService, roundMapper, store, bracketConfig) {
        this.domHelper = domHelper;
        this.bracketBuilder = bracketBuilder;
        this.matchScrollPositionCalculator = matchScrollPositionCalculator;
        this.contestantMatchesService = contestantMatchesService;
        this.roundMapper = roundMapper;
        this.store = store;
        this.bracketConfig = bracketConfig;
        this.selectedBracket$ = new BehaviorSubject(0);
        this.roundOffset$ = new BehaviorSubject(0);
        this.bracket$ = new BehaviorSubject(null);
        this.segmentOffset$ = new BehaviorSubject(0);
        this.upperBracketMatchHeight = this.bracketConfig.upperBracketMatchHeight;
        this.lowerBracketMatchHeight = this.bracketConfig.lowerBracketMatchHeight;
        this.matchHeight = this.bracketConfig.upperBracketMatchHeight;
    }
    ngOnChanges(changes) {
        if (changes.matches && this.matches.length) {
            this.bracket$.next(this.bracketBuilder.build(this.matches));
        }
        //check if contestant is set to a truthy value, as changes.selectedParticipant is set on EVERY change, even
        //when it's initialized (to a possible undefined / null).
        if (changes.selectedParticipant && this.selectedParticipant && this.bracket$.getValue()) {
            this.jumpToContestant(this.selectedParticipant);
        }
    }
    goToMyPosition() {
        this.store.dispatch(new SelectParticipantAction(this.league.id, this.ownContestant));
        this.jumpToContestant(this.ownContestant);
    }
    /**
     * Select the bracket to be displayed.
     * 0 == upper bracket.
     * 1 == lower bracket / third place match.
     *
     * @param bracketIndex Specify to display lower or upper bracket.
     */
    selectBracket(bracketIndex, roundIndex) {
        if (document.getElementById("segmented-bracket-renderer")) {
            const bracket = document.getElementsByClassName("c-cup-bracket")[0];
            if (!bracket) {
                return;
            }
            const cupPage = this.domHelper.findWindowOffsetTop(bracket);
            if (window.scrollY > cupPage) {
                window.scrollTo(0, cupPage);
            }
        }
        if (bracketIndex === this.selectedBracket$.getValue()) {
            return;
        }
        if (!roundIndex) {
            if (this.hasThirdPlaceMatch) {
                if (this.selectedBracket$.getValue() === 0) {
                    roundIndex = this.roundMapper.getThirdPlaceMatchRoundIndex();
                }
                else {
                    roundIndex = this.roundMapper.getUpperBracketRoundIndexForThirdPlaceMatch(this.bracket$.getValue()[bracketIndex].length);
                }
            }
            else {
                if (this.selectedBracket$.getValue() === 0) {
                    roundIndex = this.roundMapper.getLowerBracketRoundIndexForUpperBracketRoundIndex(this.roundOffset$.getValue());
                }
                else {
                    roundIndex = this.roundMapper.getUpperBracketRoundIndexForLowerBracketRoundIndex(this.roundOffset$.getValue());
                }
            }
        }
        this.selectedBracket$.next(bracketIndex);
        this.setRoundOffset(roundIndex);
    }
    /**
     * Select a range of rounds to be displayed.
     * @param offset
     */
    setRoundOffset(offset) {
        if (!this.bracket$.getValue()) {
            return;
        }
        const newOffset = Math.min(this.bracket$.getValue()[this.selectedBracket$.getValue()].length - this.roundDisplayAmount, Math.max(0, offset));
        const goingLeft = newOffset < this.roundOffset$.getValue();
        const goingRight = newOffset > this.roundOffset$.getValue();
        this.roundOffset$.next(Math.max(0, newOffset));
        if (goingLeft) {
            this.navigate(this.topLeftMatch);
        }
        else if (goingRight) {
            this.navigate(this.topSecondFromLeftMatch);
        }
    }
    setTopLeftMatch(match) {
        if (match) {
            this.topLeftMatch = match;
        }
    }
    setTopSecondFromLeftMatch(match) {
        if (match) {
            this.topSecondFromLeftMatch = match;
        }
    }
    navigate(match) {
        if (!match) {
            return;
        }
        const roundIndex = match.bracket === 1 ? match.round - 1 : match.round;
        this.matchHeight = match.bracket === 1 ? this.lowerBracketMatchHeight : this.upperBracketMatchHeight;
        setTimeout(() => {
            const matchIndex = findIndex(this.bracket$.getValue()[match.bracket][roundIndex], (bracketMatch) => match.id === bracketMatch.id);
            const bracketContainer = document.getElementById("segmented-bracket-renderer");
            const bracket = document.getElementsByClassName("c-cup-bracket")[0];
            if (!bracketContainer || !bracket) {
                return;
            }
            const topOfCupBracket = this.domHelper.findWindowOffsetTop(bracketContainer);
            const cupPage = this.domHelper.findWindowOffsetTop(bracket);
            if (window.scrollY > cupPage) {
                window.scrollTo(0, topOfCupBracket +
                    this.matchScrollPositionCalculator.calculateRelativeMatchPosition(matchIndex, roundIndex, match.bracket, this.roundOffset$.getValue()) -
                    this.matchHeight * 2);
            }
        });
    }
    /**
     * Jump to a given contestants position in the bracket.
     * Select the appropiate bracket & scroll to position.
     *
     * @param contestant
     */
    jumpToContestant(contestant) {
        const lastMatch = this.contestantMatchesService.getLastMatchForContestant(contestant, this.matches);
        const roundIndexOfLastMatch = this.contestantMatchesService.getLastMatchRoundIndexForContestant(contestant, this.bracket$.getValue(), lastMatch.bracket);
        const newOffset = roundIndexOfLastMatch + Math.ceil(this.roundDisplayAmount / 2) - this.roundDisplayAmount;
        if (lastMatch.bracket !== this.selectedBracket$.getValue()) {
            this.selectBracket(lastMatch.bracket, newOffset);
        }
        else {
            this.setRoundOffset(newOffset);
        }
        setTimeout(() => {
            const matchIndex = findIndex(this.bracket$.getValue()[lastMatch.bracket][roundIndexOfLastMatch], (match) => lastMatch.id === match.id);
            const bracketContainer = document.getElementById("segmented-bracket-renderer");
            if (!bracketContainer) {
                return;
            }
            const topOfCupBracket = this.domHelper.findWindowOffsetTop(bracketContainer);
            window.scrollTo(0, topOfCupBracket +
                this.matchScrollPositionCalculator.calculateRelativeMatchPosition(matchIndex, roundIndexOfLastMatch, lastMatch.bracket, this.roundOffset$.getValue()) -
                window.innerHeight / 2);
        });
    }
    /**
     * Set segment offset.
     */
    setSegmentOffset(offset) {
        this.segmentOffset$.next(offset);
    }
}
PlayCupBracketComponent.ɵfac = function PlayCupBracketComponent_Factory(t) { return new (t || PlayCupBracketComponent)(i0.ɵɵdirectiveInject(DOMHelper), i0.ɵɵdirectiveInject(BracketBuilder), i0.ɵɵdirectiveInject(MatchScrollPositionCalculator), i0.ɵɵdirectiveInject(ContestantMatchesService), i0.ɵɵdirectiveInject(RoundMapper), i0.ɵɵdirectiveInject(i1$1.Store), i0.ɵɵdirectiveInject(BRACKET_CONFIG)); };
PlayCupBracketComponent.ɵcmp = i0.ɵɵdefineComponent({ type: PlayCupBracketComponent, selectors: [["cup-bracket"]], inputs: { league: "league", ownContestant: "ownContestant", selectedParticipant: "selectedParticipant", matches: "matches", participants: "participants", isDoubleElimination: "isDoubleElimination", hasThirdPlaceMatch: "hasThirdPlaceMatch", roundDisplayAmount: "roundDisplayAmount" }, features: [i0.ɵɵNgOnChangesFeature], decls: 3, vars: 2, consts: [[1, "c-cup-bracket"], ["class", "c-cup-bracket__wrapper", 4, "ngIf"], ["class", "c-cup-bracket__no-bracket", 4, "ngIf"], [1, "c-cup-bracket__wrapper"], [1, "cup-bracket-navigation--sticky"], [1, "c-cup-bracket__controls"], [3, "isDoubleElimination", "hasThirdPlaceMatch", "selectedBracket", "selected"], [3, "click", 4, "ngIf"], ["pageType", "bracket", 1, "cup-page-switcher", 3, "leagueId"], [3, "league", "isLowerBracket", "rounds", "roundDisplayAmount", "offset", "setOffset", 4, "ngIf"], [3, "rounds", "roundOffset", "roundDisplayAmount", "league", "ownContestant", "participants", "selectedParticipant", "isDoubleElimination", "hasThirdPlaceMatch", "isLowerBracket", "segmentOffset", "setSegmentOffset", "getTopLeftMatch", "getTopSecondFromLeftMatch", 4, "ngIf"], [3, "click"], [3, "league", "isLowerBracket", "rounds", "roundDisplayAmount", "offset", "setOffset"], [3, "rounds", "roundOffset", "roundDisplayAmount", "league", "ownContestant", "participants", "selectedParticipant", "isDoubleElimination", "hasThirdPlaceMatch", "isLowerBracket", "segmentOffset", "setSegmentOffset", "getTopLeftMatch", "getTopSecondFromLeftMatch"], [1, "c-cup-bracket__no-bracket"]], template: function PlayCupBracketComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "article", 0);
        i0.ɵɵtemplate(1, PlayCupBracketComponent_div_1_Template, 11, 13, "div", 1);
        i0.ɵɵtemplate(2, PlayCupBracketComponent_div_2_Template, 3, 3, "div", 2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.matches.length);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.matches.length);
    } }, directives: [i2.NgIf, CupBracketSelectorComponent, i9.ParticipantSwitcherComponent, CupMyPositionButtonComponent, CupBracketNavigationComponent, SegmentedBracketRendererComponent], pipes: [i2.AsyncPipe, i3.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlayCupBracketComponent, [{
        type: Component,
        args: [{
                selector: "cup-bracket",
                templateUrl: "./play-cup-bracket.component.html",
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: DOMHelper }, { type: BracketBuilder }, { type: MatchScrollPositionCalculator }, { type: ContestantMatchesService }, { type: RoundMapper }, { type: i1$1.Store }, { type: undefined, decorators: [{
                type: Inject,
                args: [BRACKET_CONFIG]
            }] }]; }, { league: [{
            type: Input
        }], ownContestant: [{
            type: Input
        }], selectedParticipant: [{
            type: Input
        }], matches: [{
            type: Input
        }], participants: [{
            type: Input
        }], isDoubleElimination: [{
            type: Input
        }], hasThirdPlaceMatch: [{
            type: Input
        }], roundDisplayAmount: [{
            type: Input
        }] }); })();

const cupBracketReducers = {
    highlightedContestant: highlightedContestantReducer,
};

const isUpperBracket = match => match.bracket === 0;
const isLowerBracket = match => match.bracket === 1;
class MatchFinder {
    constructor(doubleElim) {
        this.doubleElim = doubleElim;
    }
    findMostInterestingMatch(matches) {
        const openMatches = matches.filter(match => match.state === "open");
        const upperBracketMatch = this.findMostInterestingUpperBracketMatch(openMatches, matches);
        if (this.doubleElim.isDoubleEliminationCupMode(matches)) {
            const lowerBracketMatch = this.findMostInterestingLowerBracketMatch(openMatches, matches);
            return upperBracketMatch.round <= lowerBracketMatch.round ? upperBracketMatch : lowerBracketMatch;
        }
        return upperBracketMatch;
    }
    findMostInterestingUpperBracketMatch(openMatches, matches) {
        const upperBracketMatches = openMatches.filter(isUpperBracket);
        if (!upperBracketMatches.length) {
            return maxBy(matches.filter(isUpperBracket), (match) => match.round);
        }
        return this.getEarliestMatch(upperBracketMatches);
    }
    findMostInterestingLowerBracketMatch(openMatches, matches) {
        const lowerBracketMatches = openMatches.filter(isLowerBracket);
        if (!lowerBracketMatches.length) {
            return maxBy(matches.filter(isLowerBracket), (match) => match.round);
        }
        return this.getEarliestMatch(lowerBracketMatches);
    }
    getEarliestMatch(matches) {
        const earliestOpenRound = minBy(matches, (match) => match.round).round;
        return minBy(matches.filter(match => match.round === earliestOpenRound), (match) => match.position);
    }
}
MatchFinder.ɵfac = function MatchFinder_Factory(t) { return new (t || MatchFinder)(i0.ɵɵinject(i2$1.DoubleEliminationService)); };
MatchFinder.ɵprov = i0.ɵɵdefineInjectable({ token: MatchFinder, factory: MatchFinder.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MatchFinder, [{
        type: Injectable
    }], function () { return [{ type: i2$1.DoubleEliminationService }]; }, null); })();

function CupPageCupBracketComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function CupPageCupBracketComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function CupPageCupBracketComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function CupPageCupBracketComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "path-view-stats-box", 4);
    i0.ɵɵelement(1, "cup-bracket", 5);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵpipe(4, "async");
    i0.ɵɵpipe(5, "async");
    i0.ɵɵpipe(6, "async");
    i0.ɵɵpipe(7, "async");
    i0.ɵɵpipe(8, "async");
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("leagueId", ctx_r4.leagueId);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ownContestant", i0.ɵɵpipeBind1(2, 9, ctx_r4.ownContestant$).entry)("selectedParticipant", i0.ɵɵpipeBind1(3, 11, ctx_r4.selectedParticipant$))("league", i0.ɵɵpipeBind1(4, 13, ctx_r4.league$).entry)("participants", i0.ɵɵpipeBind1(5, 15, ctx_r4.participants$).entry)("matches", i0.ɵɵpipeBind1(6, 17, ctx_r4.matches$).entry)("isDoubleElimination", i0.ɵɵpipeBind1(7, 19, ctx_r4.isDoubleElimination$))("hasThirdPlaceMatch", i0.ɵɵpipeBind1(8, 21, ctx_r4.hasThirdPlaceMatch$))("roundDisplayAmount", 4);
} }
function CupPageCupBracketComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "loading-spinner");
} }
function CupPageCupBracketComponent_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "inline-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "commons:data-fetch-error"), " ");
} }
class CupPageCupBracketComponent {
    constructor(store, doubleElimination, matchService, matchFinder) {
        this.store = store;
        this.doubleElimination = doubleElimination;
        this.matchService = matchService;
        this.matchFinder = matchFinder;
    }
    ngOnInit() {
        this.store.dispatch(new LoadLeagueOnceAction(this.leagueId));
        this.league$ = this.store.select(getLeague(this.leagueId));
        this.store.dispatch(new LoadParticipantsOnceAction(this.leagueId));
        this.participants$ = this.store.select(getLeagueParticipants(this.leagueId)).pipe(filter(exists), map(entry => (Object.assign(Object.assign({}, entry), { entry: entry.entry ? keyBy(entry.entry.filter(isCheckedIn), p => p.id) : entry.entry }))));
        const user$ = this.store.select(getUser).pipe(filter(user => Boolean(!user.loading || user.entry)), map(user => user.entry));
        const participants$ = this.participants$.pipe(filter(entryAvailable));
        this.ownContestant$ = combineLatest(user$, participants$).pipe(switchMap(([user, participants]) => {
            if (!user) {
                return [
                    {
                        loading: false,
                        entry: null,
                        error: null,
                    },
                ];
            }
            this.store.dispatch(new LoadContestantsOnceAction(this.leagueId, +user.id));
            return this.store.select(getContestants(this.leagueId, +user.id)).pipe(map(contestants => {
                const isParticipating = contestants.entry && contestants.entry.length && participants[contestants.entry[0].id];
                const isLoading = Boolean(contestants.loading && !contestants.entry);
                return Object.assign(Object.assign({}, contestants), { loading: isLoading, entry: isParticipating ? +contestants.entry[0].id : null });
            }));
        }));
        this.store.dispatch(new LoadLeagueResultsOnceAction(this.leagueId));
        this.matches$ = this.store.select(getLeagueResults(this.leagueId)).pipe(filter(exists), map(entry => (Object.assign(Object.assign({}, entry), { entry: entry.entry ? sortBy(entry.entry, ["round", "position", "bracket"]) : entry.entry }))));
        this.store.dispatch(new InitSelectedParticipantAction(this.leagueId, () => {
            const match$ = this.matches$.pipe(filter(entryAvailable), map(matches => matches.entry), map(matches => this.matchFinder.findMostInterestingUpperBracketMatch(matches.filter(match => match.state === "open"), matches)));
            return combineLatest(match$, participants$).pipe(distinct(([match, participants]) => {
                if (!match) {
                    return null;
                }
                const highestSeedParticipant = minBy(match.participants.filter(p => participants.entry[p.id]), (p) => participants.entry[p.id]);
                return highestSeedParticipant ? highestSeedParticipant.id : null;
            }));
        }));
        this.selectedParticipant$ = this.store.pipe(getSelectedParticipant(this.leagueId), filter(Boolean));
        this.isDoubleElimination$ = this.matches$.pipe(filter(entryAvailable), map(matches => matches.entry), map(matches => this.doubleElimination.isDoubleEliminationCupMode(matches)));
        this.hasThirdPlaceMatch$ = this.matches$.pipe(filter(entryAvailable), map(matches => matches.entry), map(matches => this.matchService.hasThirdPlaceMatch(matches)));
        this.isLoading$ = this.getIsLoading();
        this.hasError$ = this.getHasError();
        this.isReady$ = this.getIsReady();
    }
    getIsReady() {
        return combineLatest(this.isLoading$, this.hasError$).pipe(map(([loading, error]) => Boolean(!loading && !error)));
    }
    getHasError() {
        return combineLatest(this.league$, this.participants$, this.ownContestant$, this.matches$).pipe(map(data => {
            return data.filter(entry => Boolean(entry && entry.error)).length > 0;
        }));
    }
    getIsLoading() {
        return combineLatest(this.league$, this.participants$, this.ownContestant$, this.matches$).pipe(map(data => {
            return data.filter(entry => Boolean(!entry || (entry.loading && !entry.entry))).length !== 0;
        }));
    }
}
CupPageCupBracketComponent.ɵfac = function CupPageCupBracketComponent_Factory(t) { return new (t || CupPageCupBracketComponent)(i0.ɵɵdirectiveInject(i1$1.Store), i0.ɵɵdirectiveInject(i2$1.DoubleEliminationService), i0.ɵɵdirectiveInject(i2$1.MatchService), i0.ɵɵdirectiveInject(MatchFinder)); };
CupPageCupBracketComponent.ɵcmp = i0.ɵɵdefineComponent({ type: CupPageCupBracketComponent, selectors: [["cup-bracket-cup-page"]], inputs: { leagueId: "leagueId" }, decls: 12, vars: 12, consts: [[4, "ngIf", "ngIfThen"], ["ready", ""], ["loading", ""], ["error", ""], [3, "leagueId"], [3, "ownContestant", "selectedParticipant", "league", "participants", "matches", "isDoubleElimination", "hasThirdPlaceMatch", "roundDisplayAmount"]], template: function CupPageCupBracketComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, CupPageCupBracketComponent_ng_container_0_Template, 1, 0, "ng-container", 0);
        i0.ɵɵpipe(1, "async");
        i0.ɵɵtemplate(2, CupPageCupBracketComponent_ng_container_2_Template, 1, 0, "ng-container", 0);
        i0.ɵɵpipe(3, "async");
        i0.ɵɵtemplate(4, CupPageCupBracketComponent_ng_container_4_Template, 1, 0, "ng-container", 0);
        i0.ɵɵpipe(5, "async");
        i0.ɵɵtemplate(6, CupPageCupBracketComponent_ng_template_6_Template, 9, 23, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(8, CupPageCupBracketComponent_ng_template_8_Template, 1, 0, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(10, CupPageCupBracketComponent_ng_template_10_Template, 3, 3, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r3 = i0.ɵɵreference(7);
        const _r5 = i0.ɵɵreference(9);
        const _r7 = i0.ɵɵreference(11);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 6, ctx.isReady$))("ngIfThen", _r3);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(3, 8, ctx.isLoading$))("ngIfThen", _r5);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(5, 10, ctx.hasError$))("ngIfThen", _r7);
    } }, directives: [i2.NgIf, i2$1.StatsBoxComponent, PlayCupBracketComponent, i1.LoadingSpinnerComponent, i1.InlineErrorComponent], pipes: [i2.AsyncPipe, i3.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CupPageCupBracketComponent, [{
        type: Component,
        args: [{
                selector: "cup-bracket-cup-page",
                templateUrl: "./cup-page-cup-bracket.component.html",
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i1$1.Store }, { type: i2$1.DoubleEliminationService }, { type: i2$1.MatchService }, { type: MatchFinder }]; }, { leagueId: [{
            type: Input
        }] }); })();

class BracketModule {
}
BracketModule.ɵfac = function BracketModule_Factory(t) { return new (t || BracketModule)(); };
BracketModule.ɵmod = i0.ɵɵdefineNgModule({ type: BracketModule });
BracketModule.ɵinj = i0.ɵɵdefineInjector({ providers: [
        DOMHelper,
        BracketBuilder,
        BracketSegmenter,
        ContestantMatchesService,
        MatchScrollPositionCalculator,
        RoundMapper,
        MatchFinder,
        { provide: BRACKET_CONFIG, useValue: bracketBaseConfig },
    ], imports: [[
            CommonModule,
            StoreModule.forFeature("cupBracket", cupBracketReducers),
            TranslationModule,
            CupPageModule,
            PathViewStatsBoxModule,
            CommonsLoadingModule,
            CommonsErrorModule,
            PathViewModule,
            //
            BracketComponentsModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(BracketModule, { declarations: [PlayCupBracketComponent, CupPageCupBracketComponent], imports: [CommonModule, i1$1.StoreFeatureModule, TranslationModule,
        CupPageModule,
        PathViewStatsBoxModule,
        CommonsLoadingModule,
        CommonsErrorModule,
        PathViewModule,
        //
        BracketComponentsModule], exports: [PlayCupBracketComponent, CupPageCupBracketComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BracketModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    StoreModule.forFeature("cupBracket", cupBracketReducers),
                    TranslationModule,
                    CupPageModule,
                    PathViewStatsBoxModule,
                    CommonsLoadingModule,
                    CommonsErrorModule,
                    PathViewModule,
                    //
                    BracketComponentsModule,
                ],
                providers: [
                    DOMHelper,
                    BracketBuilder,
                    BracketSegmenter,
                    ContestantMatchesService,
                    MatchScrollPositionCalculator,
                    RoundMapper,
                    MatchFinder,
                    { provide: BRACKET_CONFIG, useValue: bracketBaseConfig },
                ],
                declarations: [PlayCupBracketComponent, CupPageCupBracketComponent],
                exports: [PlayCupBracketComponent, CupPageCupBracketComponent],
            }]
    }], null, null); })();

const cupBracketNavigationTexts = {
    "cup-bracket-navigation:round-of": "Round of {of}",
    "cup-bracket-navigation:lower-round-of": "Round of {of} {first, select, 1{#1} 0{#2} other{ERROR}}",
    "cup-bracket-navigation:quarter-final": "Quarterfinal",
    "cup-bracket-navigation:semi-final": "Semifinal",
    "cup-bracket-navigation:third-place-round": "Third Place",
    "cup-bracket-navigation:grand-final": "Grand Final",
    "cup-bracket-navigation:second-grand-final": "Grand Final #2",
    "cup-bracket-navigation:winner-bracket-final": "WB-Final",
    "cup-bracket-navigation:lower-bracket-final": "Lower Final",
};

/*
 * Public API Surface of cup-bracket
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BracketBuilder, BracketComponentsModule, BracketModule, BracketSegmenter, ContestantMatchesService, CupBracketNavigationButtonComponent, CupBracketNavigationComponent, CupBracketNavigationRoundComponent, CupBracketSelectorButtonComponent, CupBracketSelectorComponent, CupContestantLinkComponent, CupLowerBracketComponent, CupLowerBracketRoundComponent, CupMatchComponent, CupMatchLinkComponent, CupMatchParticipantComponent, CupMyPositionButtonComponent, CupPageCupBracketComponent, CupRoundComponent, CupUpperBracketComponent, DOMHelper, HighlightedContestantActionTypes, MatchFinder, MatchScrollPositionCalculator, PlayCupBracketComponent, RoundMapper, SegmentedBracketRendererComponent, SetHighlightedContestantAction, cupBracketNavigationTexts, cupBracketReducers, getHighlightedContestant, highlightedContestantReducer };
//# sourceMappingURL=play-cup-bracket.js.map
